import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useId, forwardRef } from "react";
import { u as useUiKitTheme } from "./useUiKitTheme-C9zsuTl3.js";
var l = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, u = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, x$1 = (e, o) => JSON.stringify(e) === JSON.stringify(o);
function i(e, o) {
  e.forEach(function(r) {
    Array.isArray(r) ? i(r, o) : o.push(r);
  });
}
function y(e) {
  let o = [];
  return i(e, o), o;
}
var a = (...e) => y(e).filter(Boolean), p = (e, o) => {
  let r = {}, c = Object.keys(e), f = Object.keys(o);
  for (let t of c) if (f.includes(t)) {
    let s = e[t], n = o[t];
    Array.isArray(s) || Array.isArray(n) ? r[t] = a(n, s) : typeof s == "object" && typeof n == "object" ? r[t] = p(s, n) : r[t] = n + " " + s;
  } else r[t] = e[t];
  for (let t of f) c.includes(t) || (r[t] = o[t]);
  return r;
}, g = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
const createClassMap = (config) => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const createParseClassName = (config) => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  const parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return (className) => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
const sortModifiers = (modifiers) => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i2 = 0; i2 < conflictGroups.length; ++i2) {
      const group = conflictGroups[i2];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = (value) => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, "length", isLengthOnly);
const isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = (value) => getIsArbitraryValue(value, "number", isNumber);
const isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
const isArbitrarySize = (value) => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, "position", isNever);
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
const isArbitraryImage = (value) => getIsArbitraryValue(value, imageLabels, isImage$1);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, "", isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage$1 = (value) => imageRegex.test(value);
const getDefaultConfig = () => {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [borderColor]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
};
const mergeConfigs = (baseConfig, {
  cacheSize,
  prefix,
  separator,
  experimentalParseClassName,
  extend = {},
  override = {}
}) => {
  overrideProperty(baseConfig, "cacheSize", cacheSize);
  overrideProperty(baseConfig, "prefix", prefix);
  overrideProperty(baseConfig, "separator", separator);
  overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
  for (const configKey in override) {
    overrideConfigProperties(baseConfig[configKey], override[configKey]);
  }
  for (const key in extend) {
    mergeConfigProperties(baseConfig[key], extend[key]);
  }
  return baseConfig;
};
const overrideProperty = (baseObject, overrideKey, overrideValue) => {
  if (overrideValue !== void 0) {
    baseObject[overrideKey] = overrideValue;
  }
};
const overrideConfigProperties = (baseObject, overrideObject) => {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
};
const mergeConfigProperties = (baseObject, mergeObject) => {
  if (mergeObject) {
    for (const key in mergeObject) {
      const mergeValue = mergeObject[key];
      if (mergeValue !== void 0) {
        baseObject[key] = (baseObject[key] || []).concat(mergeValue);
      }
    }
  }
};
const extendTailwindMerge = (configExtension, ...createConfig) => typeof configExtension === "function" ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
var ie = { twMerge: true, twMergeConfig: {}, responsiveVariants: false }, x = (s) => s || void 0, N = (...s) => x(y(s).filter(Boolean).join(" ")), R = null, v = {}, q = false, M = (...s) => (b$1) => b$1.twMerge ? ((!R || q) && (q = false, R = u(v) ? twMerge : extendTailwindMerge({ ...v, extend: { theme: v.theme, classGroups: v.classGroups, conflictingClassGroupModifiers: v.conflictingClassGroupModifiers, conflictingClassGroups: v.conflictingClassGroups, ...v.extend } })), x(R(N(s)))) : N(s), _ = (s, b) => {
  for (let e in b) s.hasOwnProperty(e) ? s[e] = N(s[e], b[e]) : s[e] = b[e];
  return s;
}, ce = (s, b$1) => {
  let { extend: e = null, slots: O = {}, variants: U = {}, compoundVariants: W = [], compoundSlots: C = [], defaultVariants: z = {} } = s, m = { ...ie, ...b$1 }, k = e != null && e.base ? N(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !u(e.variants) ? p(U, e.variants) : U, w = e != null && e.defaultVariants && !u(e.defaultVariants) ? { ...e.defaultVariants, ...z } : z;
  !u(m.twMergeConfig) && !x$1(m.twMergeConfig, v) && (q = true, v = m.twMergeConfig);
  let S = u(e == null ? void 0 : e.slots), T = u(O) ? {} : { base: N(s == null ? void 0 : s.base, S && (e == null ? void 0 : e.base)), ...O }, j = S ? T : _({ ...e == null ? void 0 : e.slots }, u(T) ? { base: s == null ? void 0 : s.base } : T), h$1 = u(e == null ? void 0 : e.compoundVariants) ? W : a(e == null ? void 0 : e.compoundVariants, W), V = (l$1) => {
    if (u(g$1) && u(O) && S) return M(k, l$1 == null ? void 0 : l$1.class, l$1 == null ? void 0 : l$1.className)(m);
    if (h$1 && !Array.isArray(h$1)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof h$1}`);
    if (C && !Array.isArray(C)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof C}`);
    let P = (a2, n, t = [], i2) => {
      let r = t;
      if (typeof n == "string") r = r.concat(g(n).split(" ").map((o) => `${a2}:${o}`));
      else if (Array.isArray(n)) r = r.concat(n.reduce((o, c) => o.concat(`${a2}:${c}`), []));
      else if (typeof n == "object" && typeof i2 == "string") {
        for (let o in n) if (n.hasOwnProperty(o) && o === i2) {
          let c = n[o];
          if (c && typeof c == "string") {
            let u2 = g(c);
            r[i2] ? r[i2] = r[i2].concat(u2.split(" ").map((f) => `${a2}:${f}`)) : r[i2] = u2.split(" ").map((f) => `${a2}:${f}`);
          } else Array.isArray(c) && c.length > 0 && (r[i2] = c.reduce((u2, f) => u2.concat(`${a2}:${f}`), []));
        }
      }
      return r;
    }, D = (a$1, n = g$1, t = null, i2 = null) => {
      var L;
      let r = n[a$1];
      if (!r || u(r)) return null;
      let o = (L = i2 == null ? void 0 : i2[a$1]) != null ? L : l$1 == null ? void 0 : l$1[a$1];
      if (o === null) return null;
      let c = l(o), u$1 = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === true, f = w == null ? void 0 : w[a$1], d = [];
      if (typeof c == "object" && u$1) for (let [E, Q] of Object.entries(c)) {
        let ne = r[Q];
        if (E === "initial") {
          f = Q;
          continue;
        }
        Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(E) || (d = P(E, ne, d, t));
      }
      let $ = c != null && typeof c != "object" ? c : l(f), A = r[$ || "false"];
      return typeof d == "object" && typeof t == "string" && d[t] ? _(d, A) : d.length > 0 ? (d.push(A), t === "base" ? d.join(" ") : d) : A;
    }, p2 = () => g$1 ? Object.keys(g$1).map((a2) => D(a2, g$1)) : null, ee = (a2, n) => {
      if (!g$1 || typeof g$1 != "object") return null;
      let t = new Array();
      for (let i2 in g$1) {
        let r = D(i2, g$1, a2, n), o = a2 === "base" && typeof r == "string" ? r : r && r[a2];
        o && (t[t.length] = o);
      }
      return t;
    }, H = {};
    for (let a2 in l$1) l$1[a2] !== void 0 && (H[a2] = l$1[a2]);
    let I = (a2, n) => {
      var i2;
      let t = typeof (l$1 == null ? void 0 : l$1[a2]) == "object" ? { [a2]: (i2 = l$1[a2]) == null ? void 0 : i2.initial } : {};
      return { ...w, ...H, ...t, ...n };
    }, J = (a2 = [], n) => {
      let t = [];
      for (let { class: i2, className: r, ...o } of a2) {
        let c = true;
        for (let [u2, f] of Object.entries(o)) {
          let d = I(u2, n)[u2];
          if (Array.isArray(f)) {
            if (!f.includes(d)) {
              c = false;
              break;
            }
          } else {
            let $ = (A) => A == null || A === false;
            if ($(f) && $(d)) continue;
            if (d !== f) {
              c = false;
              break;
            }
          }
        }
        c && (i2 && t.push(i2), r && t.push(r));
      }
      return t;
    }, te = (a2) => {
      let n = J(h$1, a2);
      if (!Array.isArray(n)) return n;
      let t = {};
      for (let i2 of n) if (typeof i2 == "string" && (t.base = M(t.base, i2)(m)), typeof i2 == "object") for (let [r, o] of Object.entries(i2)) t[r] = M(t[r], o)(m);
      return t;
    }, ae = (a2) => {
      if (C.length < 1) return null;
      let n = {};
      for (let { slots: t = [], class: i2, className: r, ...o } of C) {
        if (!u(o)) {
          let c = true;
          for (let u2 of Object.keys(o)) {
            let f = I(u2, a2)[u2];
            if (f === void 0 || (Array.isArray(o[u2]) ? !o[u2].includes(f) : o[u2] !== f)) {
              c = false;
              break;
            }
          }
          if (!c) continue;
        }
        for (let c of t) n[c] = n[c] || [], n[c].push([i2, r]);
      }
      return n;
    };
    if (!u(O) || !S) {
      let a2 = {};
      if (typeof j == "object" && !u(j)) for (let n of Object.keys(j)) a2[n] = (t) => {
        var i2, r;
        return M(j[n], ee(n, t), ((i2 = te(t)) != null ? i2 : [])[n], ((r = ae(t)) != null ? r : [])[n], t == null ? void 0 : t.class, t == null ? void 0 : t.className)(m);
      };
      return a2;
    }
    return M(k, p2(), J(h$1), l$1 == null ? void 0 : l$1.class, l$1 == null ? void 0 : l$1.className)(m);
  }, K = () => {
    if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
  };
  return V.variantKeys = K(), V.extend = e, V.base = k, V.slots = j, V.variants = g$1, V.defaultVariants = w, V.compoundSlots = C, V.compoundVariants = h$1, V;
};
const generateKeyframes = (props, extraName = "") => {
  var _a;
  if (!((_a = props == null ? void 0 : props.animation) == null ? void 0 : _a.keyframes)) {
    return "";
  }
  return `@keyframes ${props.animation.name + extraName} { ${Object.entries(
    props.animation.keyframes
  ).map(([key, css]) => {
    return `${key} {${Object.entries(css != null ? css : {}).map(([cssKey, cssValue]) => {
      return `${cssKey}: ${cssValue};`;
    }).join(" ")}}`;
  }).join(" ")} }; `;
};
const sanitizeId = (id) => {
  return id.replace(/:/g, "");
};
const generateAnimParams = (props, extraName = "") => {
  var _a, _b, _c;
  if (!(props == null ? void 0 : props.animation)) {
    return "";
  }
  return `${props.animation.name + extraName} ${(_a = props.animation.duration) != null ? _a : 0.3}s ${(_b = props.animation.transition) != null ? _b : "linear"} ${(_c = props.animation.direction) != null ? _c : "forwards"}`;
};
const useAnimation = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const id = useId();
  const style = {};
  let className = "";
  const mAnimParams = generateAnimParams(
    props.m,
    ((_b = (_a = props.m) == null ? void 0 : _a.animation) == null ? void 0 : _b.keyframes) ? sanitizeId(`-m-${id}`) : ""
  );
  const mKeyframes = generateKeyframes(
    props.m,
    ((_d = (_c = props.m) == null ? void 0 : _c.animation) == null ? void 0 : _d.keyframes) ? sanitizeId(`-m-${id}`) : ""
  );
  if (mAnimParams) {
    style[`--anim`] = mAnimParams;
    className += `[animation:var(--anim)]`;
  }
  const mdAnimParams = generateAnimParams(
    props.md,
    ((_f = (_e = props.md) == null ? void 0 : _e.animation) == null ? void 0 : _f.keyframes) ? sanitizeId(`-md-${id}`) : ""
  );
  const mdKeyframes = generateKeyframes(
    props.md,
    ((_h = (_g = props.md) == null ? void 0 : _g.animation) == null ? void 0 : _h.keyframes) ? sanitizeId(`-md-${id}`) : ""
  );
  if (mdAnimParams && mdAnimParams !== mAnimParams) {
    style[`--md-anim`] = mdAnimParams;
    className += ` md:[animation:var(--md-anim)]`;
  }
  const mdAppearAnimation = mdAnimParams != null ? mdAnimParams : mAnimParams;
  const dAnimParams = generateAnimParams(
    props.d,
    ((_j = (_i = props.d) == null ? void 0 : _i.animation) == null ? void 0 : _j.keyframes) ? sanitizeId(`-d-${id}`) : ""
  );
  const dKeyframes = generateKeyframes(
    props.d,
    ((_l = (_k = props.d) == null ? void 0 : _k.animation) == null ? void 0 : _l.keyframes) ? sanitizeId(`-d-${id}`) : ""
  );
  if (dAnimParams && dAnimParams !== mdAppearAnimation) {
    style[`--d-anim`] = dAnimParams;
    className += ` lg:[animation:var(--d-anim)]`;
  }
  const keyFrames = `${mKeyframes}${mdKeyframes}${dKeyframes}`;
  const mHoverAnimParams = generateAnimParams((_m = props.hover) == null ? void 0 : _m.m);
  if (mHoverAnimParams) {
    style[`--h-anim`] = mHoverAnimParams;
    className += ` hover:[animation:var(--h-anim)]`;
  }
  const mdHoverAnimParams = generateAnimParams((_n = props.hover) == null ? void 0 : _n.md);
  if (mdHoverAnimParams && mdHoverAnimParams !== mHoverAnimParams) {
    style[`--h-md-anim`] = mdHoverAnimParams;
    className += ` md:hover:[animation:var(--h-md-anim)]`;
  }
  const mdHoverAppearAnimation = mdHoverAnimParams != null ? mdHoverAnimParams : mHoverAnimParams;
  const dHoverAnimParams = generateAnimParams((_o = props.hover) == null ? void 0 : _o.d);
  if (dHoverAnimParams && dHoverAnimParams !== mdHoverAppearAnimation) {
    style[`--h-d-anim`] = dHoverAnimParams;
    className += ` lg:hover:[animation:var(--h-d-anim)]`;
  }
  const mActiveAnimParams = generateAnimParams((_p = props.active) == null ? void 0 : _p.m);
  if (mActiveAnimParams) {
    style[`--a-anim`] = mActiveAnimParams;
    className += ` active:[animation:var(--a-anim)]`;
  }
  const mdActiveAnimParams = generateAnimParams((_q = props.active) == null ? void 0 : _q.md);
  if (mdActiveAnimParams && mdActiveAnimParams !== mActiveAnimParams) {
    style[`--a-md-anim`] = mdActiveAnimParams;
    className += ` md:active:[animation:var(--a-md-anim)]`;
  }
  const mdActiveAppearAnimation = mdActiveAnimParams != null ? mdActiveAnimParams : mActiveAnimParams;
  const dActiveAnimParams = generateAnimParams((_r = props.active) == null ? void 0 : _r.d);
  if (dActiveAnimParams && dActiveAnimParams !== mdActiveAppearAnimation) {
    style[`--a-d-anim`] = dActiveAnimParams;
    className += ` lg:active:[animation:var(--a-d-anim)]`;
  }
  return {
    style,
    className,
    keyFrames
  };
};
const isSideWidth = (props) => {
  return typeof props === "object" && ("top" in props || "bottom" in props || "left" in props || "right" in props);
};
const isSingleWidth = (props) => {
  return typeof props === "string";
};
const transformBorderWidth = (item) => {
  if (isSideWidth(item)) {
    return item;
  }
  return {
    top: item,
    left: item,
    right: item,
    bottom: item
  };
};
const useBorderWidth = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const style = {};
  let classNames = "";
  const mBorderWidth = ((_a = props.m) == null ? void 0 : _a.width) ? transformBorderWidth((_b = props.m) == null ? void 0 : _b.width) : void 0;
  const mdBorderWidth = ((_c = props.md) == null ? void 0 : _c.width) ? transformBorderWidth((_d = props.md) == null ? void 0 : _d.width) : mBorderWidth;
  const dBorderWidth = ((_e = props.d) == null ? void 0 : _e.width) ? transformBorderWidth((_f = props.d) == null ? void 0 : _f.width) : mdBorderWidth;
  const universalMWidthValue = typeof ((_g = props.m) == null ? void 0 : _g.width) !== "undefined" && isSingleWidth((_h = props.m) == null ? void 0 : _h.width) ? (_i = props.m) == null ? void 0 : _i.width : void 0;
  if ((_l = (_k = (_j = mBorderWidth == null ? void 0 : mBorderWidth.top) != null ? _j : mBorderWidth == null ? void 0 : mBorderWidth.right) != null ? _k : mBorderWidth == null ? void 0 : mBorderWidth.bottom) != null ? _l : mBorderWidth == null ? void 0 : mBorderWidth.left) {
    if (typeof universalMWidthValue !== "undefined") {
      style["--b-width"] = universalMWidthValue;
      classNames += `[border-width:var(--b-width)] `;
    } else {
      if (typeof (mBorderWidth == null ? void 0 : mBorderWidth.top) !== "undefined") {
        style["--top-b-width"] = mBorderWidth == null ? void 0 : mBorderWidth.top;
        classNames += `[border-top-width:var(--top-b-width)] `;
      }
      if (typeof (mBorderWidth == null ? void 0 : mBorderWidth.right) !== "undefined") {
        style["--bottom-r-width"] = mBorderWidth == null ? void 0 : mBorderWidth.right;
        classNames += `[border-right-width:var(--bottom-r-width)] `;
      }
      if (typeof (mBorderWidth == null ? void 0 : mBorderWidth.bottom) !== "undefined") {
        style["--bottom-b-width"] = mBorderWidth == null ? void 0 : mBorderWidth.bottom;
        classNames += `[border-bottom-width:var(--bottom-b-width)] `;
      }
      if (typeof (mBorderWidth == null ? void 0 : mBorderWidth.left) !== "undefined") {
        style["--bottom-l-width"] = mBorderWidth == null ? void 0 : mBorderWidth.left;
        classNames += `[border-left-width:var(--bottom-l-width)] `;
      }
    }
  }
  const universalMdWidthValue = typeof ((_m = props == null ? void 0 : props.md) == null ? void 0 : _m.width) !== "undefined" && isSingleWidth(props.md.width) ? props.md.width : void 0;
  if ((_p = (_o = (_n = mdBorderWidth == null ? void 0 : mdBorderWidth.top) != null ? _n : mdBorderWidth == null ? void 0 : mdBorderWidth.right) != null ? _o : mdBorderWidth == null ? void 0 : mdBorderWidth.bottom) != null ? _p : mdBorderWidth == null ? void 0 : mdBorderWidth.left) {
    if (typeof universalMdWidthValue !== "undefined") {
      style["--md-b-width"] = universalMdWidthValue;
      classNames += `md:[border-width:var(--md-b-width)] `;
    } else {
      if (typeof (mdBorderWidth == null ? void 0 : mdBorderWidth.top) !== "undefined") {
        style["--md-top-b-width"] = mdBorderWidth == null ? void 0 : mdBorderWidth.top;
        classNames += `md:[border-top-width:var(--md-top-b-width)] `;
      }
      if (typeof (mdBorderWidth == null ? void 0 : mdBorderWidth.right) !== "undefined") {
        style["--md-right-b-width"] = mdBorderWidth == null ? void 0 : mdBorderWidth.right;
        classNames += `md:[border-right-width:var(--md-right-b-width)] `;
      }
      if (typeof (mdBorderWidth == null ? void 0 : mdBorderWidth.bottom) !== "undefined") {
        style["--md-bottom-b-width"] = mdBorderWidth == null ? void 0 : mdBorderWidth.bottom;
        classNames += `md:[border-bottom-width:var(--md-bottom-b-width)] `;
      }
      if (typeof (mdBorderWidth == null ? void 0 : mdBorderWidth.left) !== "undefined") {
        style["--md-left-b-width"] = mdBorderWidth == null ? void 0 : mdBorderWidth.left;
        classNames += `md:[border-left-width:var(--md-left-b-width)] `;
      }
    }
  }
  const universalDWidthValue = typeof ((_q = props == null ? void 0 : props.d) == null ? void 0 : _q.width) !== "undefined" && isSingleWidth(props.d.width) ? props.d.width : void 0;
  if ((_t = (_s = (_r = dBorderWidth == null ? void 0 : dBorderWidth.top) != null ? _r : dBorderWidth == null ? void 0 : dBorderWidth.right) != null ? _s : dBorderWidth == null ? void 0 : dBorderWidth.bottom) != null ? _t : dBorderWidth == null ? void 0 : dBorderWidth.left) {
    if (typeof universalDWidthValue !== "undefined") {
      style["--d-b-width"] = universalDWidthValue;
      classNames += `lg:[border-width:var(--d-b-width)] `;
    } else {
      if (typeof (dBorderWidth == null ? void 0 : dBorderWidth.top) !== "undefined") {
        style["--d-top-b-width"] = dBorderWidth == null ? void 0 : dBorderWidth.top;
        classNames += `lg:[border-top-width:var(--d-top-b-width)] `;
      }
      if (typeof (dBorderWidth == null ? void 0 : dBorderWidth.right) !== "undefined") {
        style["--d-right-b-width"] = dBorderWidth == null ? void 0 : dBorderWidth.right;
        classNames += `lg:[border-right-width:var(--d-right-b-width)] `;
      }
      if (typeof (dBorderWidth == null ? void 0 : dBorderWidth.bottom) !== "undefined") {
        style["--d-bottom-b-width"] = dBorderWidth == null ? void 0 : dBorderWidth.bottom;
        classNames += `lg:[border-bottom-width:var(--d-bottom-b-width)] `;
      }
      if (typeof (dBorderWidth == null ? void 0 : dBorderWidth.left) !== "undefined") {
        style["--d-left-b-width"] = dBorderWidth == null ? void 0 : dBorderWidth.left;
        classNames += `lg:[border-left-width:var(--d-left-b-width)] `;
      }
    }
  }
  return {
    className: classNames.trim(),
    style
  };
};
const isSideColors = (props) => {
  return typeof props === "object" && ("top" in props || "bottom" in props || "left" in props || "right" in props);
};
const isSingleColor = (props) => {
  return typeof props === "string";
};
const transformBorderColor = (item) => {
  if (isSideColors(item)) {
    return item;
  }
  return {
    top: item,
    left: item,
    right: item,
    bottom: item
  };
};
const isSingleRadius = (value) => {
  return typeof value === "string";
};
const transformBorderRadius = (item) => {
  if (isSingleRadius(item)) {
    return {
      topLeft: item,
      topRight: item,
      bottomLeft: item,
      bottomRight: item
    };
  }
  return item;
};
const useBorder = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La, _Ma, _Na, _Oa, _Pa, _Qa, _Ra, _Sa, _Ta, _Ua, _Va, _Wa, _Xa, _Ya, _Za, __a, _$a, _ab, _bb, _cb, _db, _eb, _fb, _gb, _hb, _ib, _jb, _kb, _lb, _mb, _nb, _ob, _pb, _qb, _rb, _sb, _tb, _ub, _vb, _wb, _xb, _yb, _zb, _Ab, _Bb, _Cb, _Db, _Eb, _Fb, _Gb, _Hb, _Ib, _Jb, _Kb, _Lb, _Mb, _Nb, _Ob, _Pb, _Qb, _Rb, _Sb, _Tb, _Ub, _Vb, _Wb, _Xb, _Yb, _Zb, __b, _$b, _ac, _bc, _cc, _dc;
  const style = {};
  let classNames = "";
  const { borderRadius } = useUiKitTheme();
  const mRadius = ((_a = props.m) == null ? void 0 : _a.radius) ? transformBorderRadius(props.m.radius) : void 0;
  const mdRadius = ((_b = props.md) == null ? void 0 : _b.radius) ? transformBorderRadius((_c = props.md) == null ? void 0 : _c.radius) : mRadius;
  const dRadius = ((_d = props.d) == null ? void 0 : _d.radius) ? transformBorderRadius((_e = props.d) == null ? void 0 : _e.radius) : void 0;
  const universalMRadiusValue = typeof ((_f = props.m) == null ? void 0 : _f.radius) !== "undefined" && isSingleRadius((_g = props.m) == null ? void 0 : _g.radius) ? (_j = borderRadius[(_h = props.m) == null ? void 0 : _h.radius]) != null ? _j : (_i = props.m) == null ? void 0 : _i.radius : void 0;
  if ((_m = (_l = (_k = mRadius == null ? void 0 : mRadius.topLeft) != null ? _k : mRadius == null ? void 0 : mRadius.topRight) != null ? _l : mRadius == null ? void 0 : mRadius.bottomLeft) != null ? _m : mRadius == null ? void 0 : mRadius.bottomRight) {
    if (typeof universalMRadiusValue !== "undefined") {
      style["--br"] = universalMRadiusValue;
      classNames += `rounded-[var(--br)] `;
    } else {
      if (typeof (mRadius == null ? void 0 : mRadius.topLeft) !== "undefined") {
        style["--tl-br"] = (_n = borderRadius[mRadius == null ? void 0 : mRadius.topLeft]) != null ? _n : mRadius == null ? void 0 : mRadius.topLeft;
        classNames += `rounded-tl-[var(--tl-br)] `;
      }
      if (typeof (mRadius == null ? void 0 : mRadius.topRight) !== "undefined") {
        style["--tr-br"] = (_o = borderRadius[mRadius == null ? void 0 : mRadius.topRight]) != null ? _o : mRadius == null ? void 0 : mRadius.topRight;
        classNames += `rounded-tr-[var(--tr-br)] `;
      }
      if (typeof (mRadius == null ? void 0 : mRadius.bottomLeft) !== "undefined") {
        style["--bl-br"] = (_p = borderRadius[mRadius == null ? void 0 : mRadius.bottomLeft]) != null ? _p : mRadius == null ? void 0 : mRadius.bottomLeft;
        classNames += `rounded-bl-[var(--bl-br)] `;
      }
      if (typeof (mRadius == null ? void 0 : mRadius.bottomRight) !== "undefined") {
        style["--br-br"] = (_q = borderRadius[mRadius == null ? void 0 : mRadius.bottomRight]) != null ? _q : mRadius == null ? void 0 : mRadius.bottomRight;
        classNames += `rounded-br-[var(--br-br)] `;
      }
    }
  }
  const universalMdRadiusValue = typeof ((_r = props == null ? void 0 : props.md) == null ? void 0 : _r.radius) !== "undefined" && isSingleRadius(props.md.radius) ? (_t = borderRadius[(_s = props.md) == null ? void 0 : _s.radius]) != null ? _t : props.md.radius : void 0;
  if ((_w = (_v = (_u = mdRadius == null ? void 0 : mdRadius.topLeft) != null ? _u : mdRadius == null ? void 0 : mdRadius.topRight) != null ? _v : mdRadius == null ? void 0 : mdRadius.bottomLeft) != null ? _w : mdRadius == null ? void 0 : mdRadius.bottomRight) {
    if (typeof universalMdRadiusValue !== "undefined") {
      style["--md-br"] = universalMdRadiusValue;
      classNames += `md:rounded-[var(--md-br)] `;
    } else {
      if (typeof (mdRadius == null ? void 0 : mdRadius.topLeft) !== "undefined") {
        style["--md-tl-br"] = (_x = borderRadius[mdRadius == null ? void 0 : mdRadius.topLeft]) != null ? _x : mdRadius == null ? void 0 : mdRadius.topLeft;
        classNames += `md:rounded-tl-[var(--md-tl-br)] `;
      }
      if (typeof (mdRadius == null ? void 0 : mdRadius.topRight) !== "undefined") {
        style["--md-tr-br"] = (_y = borderRadius[mdRadius == null ? void 0 : mdRadius.topRight]) != null ? _y : mdRadius == null ? void 0 : mdRadius.topRight;
        classNames += `md:rounded-tr-[var(--md-tr-br)] `;
      }
      if (typeof (mdRadius == null ? void 0 : mdRadius.bottomLeft) !== "undefined") {
        style["--md-bl-br"] = (_z = borderRadius[mdRadius == null ? void 0 : mdRadius.bottomLeft]) != null ? _z : mdRadius == null ? void 0 : mdRadius.bottomLeft;
        classNames += `md:rounded-bl-[var(--md-bl-br)] `;
      }
      if (typeof (mdRadius == null ? void 0 : mdRadius.bottomRight) !== "undefined") {
        style["--md-br-br"] = (_A = borderRadius[mdRadius == null ? void 0 : mdRadius.bottomRight]) != null ? _A : mdRadius == null ? void 0 : mdRadius.bottomRight;
        classNames += `md:rounded-br-[var(--md-br-br)] `;
      }
    }
  }
  const universalDRadiusValue = typeof ((_B = props == null ? void 0 : props.d) == null ? void 0 : _B.radius) !== "undefined" && isSingleRadius(props.d.radius) ? (_D = borderRadius[(_C = props.d) == null ? void 0 : _C.radius]) != null ? _D : props.d.radius : void 0;
  if ((_G = (_F = (_E = dRadius == null ? void 0 : dRadius.topLeft) != null ? _E : dRadius == null ? void 0 : dRadius.topRight) != null ? _F : dRadius == null ? void 0 : dRadius.bottomLeft) != null ? _G : dRadius == null ? void 0 : dRadius.bottomRight) {
    if (typeof universalDRadiusValue !== "undefined") {
      style["--d-br"] = universalDRadiusValue;
      classNames += `lg:rounded-[var(--d-br)] `;
    } else {
      if (typeof (dRadius == null ? void 0 : dRadius.topLeft) !== "undefined") {
        style["--d-tl-br"] = (_H = borderRadius[dRadius.topLeft]) != null ? _H : dRadius == null ? void 0 : dRadius.topLeft;
        classNames += `lg:rounded-tl-[var(--d-tl-br)] `;
      }
      if (typeof (dRadius == null ? void 0 : dRadius.topRight) !== "undefined") {
        style["--d-tr-br"] = (_I = borderRadius[dRadius.topRight]) != null ? _I : dRadius == null ? void 0 : dRadius.topRight;
        classNames += `lg:rounded-tr-[var(--d-tr-br)] `;
      }
      if (typeof (dRadius == null ? void 0 : dRadius.bottomLeft) !== "undefined") {
        style["--d-bl-br"] = (_J = borderRadius[dRadius.bottomLeft]) != null ? _J : dRadius == null ? void 0 : dRadius.bottomLeft;
        classNames += `lg:rounded-bl-[var(--d-bl-br)] `;
      }
      if (typeof (dRadius == null ? void 0 : dRadius.bottomRight) !== "undefined") {
        style["--d-br-br"] = (_K = borderRadius[dRadius.bottomRight]) != null ? _K : dRadius == null ? void 0 : dRadius.bottomRight;
        classNames += `lg:rounded-br-[var(--d-br-br)] `;
      }
    }
  }
  const mHoverRadius = ((_M = (_L = props == null ? void 0 : props.hover) == null ? void 0 : _L.m) == null ? void 0 : _M.radius) ? transformBorderRadius((_N = props == null ? void 0 : props.hover) == null ? void 0 : _N.m.radius) : void 0;
  const mdHoverRadius = ((_P = (_O = props == null ? void 0 : props.hover) == null ? void 0 : _O.md) == null ? void 0 : _P.radius) ? transformBorderRadius((_Q = props == null ? void 0 : props.hover) == null ? void 0 : _Q.md.radius) : mHoverRadius;
  const dHoverRadius = ((_S = (_R = props == null ? void 0 : props.hover) == null ? void 0 : _R.d) == null ? void 0 : _S.radius) ? transformBorderRadius((_U = (_T = props == null ? void 0 : props.hover) == null ? void 0 : _T.d) == null ? void 0 : _U.radius) : void 0;
  const universalMRadiusHoverValue = ((_W = (_V = props == null ? void 0 : props.hover) == null ? void 0 : _V.m) == null ? void 0 : _W.radius) && isSingleRadius((_X = props == null ? void 0 : props.hover) == null ? void 0 : _X.m.radius) ? (_$ = borderRadius[(_Z = (_Y = props.hover) == null ? void 0 : _Y.m) == null ? void 0 : _Z.radius]) != null ? _$ : (__ = props == null ? void 0 : props.hover) == null ? void 0 : __.m.radius : void 0;
  if ((_ca = (_ba = (_aa = mHoverRadius == null ? void 0 : mHoverRadius.topLeft) != null ? _aa : mHoverRadius == null ? void 0 : mHoverRadius.topRight) != null ? _ba : mHoverRadius == null ? void 0 : mHoverRadius.bottomLeft) != null ? _ca : mHoverRadius == null ? void 0 : mHoverRadius.bottomRight) {
    if (typeof universalMRadiusHoverValue !== "undefined") {
      style["--h-br"] = universalMRadiusHoverValue;
      classNames += `hover:rounded-[var(--h-br)] `;
    } else {
      if (typeof (mHoverRadius == null ? void 0 : mHoverRadius.topLeft) !== "undefined") {
        style["--h-tl-br"] = (_da = borderRadius[mHoverRadius == null ? void 0 : mHoverRadius.topLeft]) != null ? _da : mHoverRadius == null ? void 0 : mHoverRadius.topLeft;
        classNames += `hover:rounded-tl-[var(--h-tl-br)] `;
      }
      if (typeof (mHoverRadius == null ? void 0 : mHoverRadius.topRight) !== "undefined") {
        style["--h-tr-br"] = (_ea = borderRadius[mHoverRadius == null ? void 0 : mHoverRadius.topRight]) != null ? _ea : mHoverRadius == null ? void 0 : mHoverRadius.topRight;
        classNames += `hover:rounded-tr-[var(--h-tr-br)] `;
      }
      if (typeof (mHoverRadius == null ? void 0 : mHoverRadius.bottomLeft) !== "undefined") {
        style["--h-bl-br"] = (_fa = borderRadius[mHoverRadius == null ? void 0 : mHoverRadius.bottomLeft]) != null ? _fa : mHoverRadius == null ? void 0 : mHoverRadius.bottomLeft;
        classNames += `hover:rounded-bl-[var(--h-bl-br)] `;
      }
      if (typeof (mHoverRadius == null ? void 0 : mHoverRadius.bottomRight) !== "undefined") {
        style["--h-br-br"] = (_ga = borderRadius[mHoverRadius == null ? void 0 : mHoverRadius.bottomRight]) != null ? _ga : mHoverRadius == null ? void 0 : mHoverRadius.bottomRight;
        classNames += `hover:rounded-br-[var(--h-br-br)] `;
      }
    }
  }
  const universalMdRadiusHoverValue = typeof ((_ia = (_ha = props == null ? void 0 : props.hover) == null ? void 0 : _ha.md) == null ? void 0 : _ia.radius) !== "undefined" && isSingleRadius((_ja = props.hover) == null ? void 0 : _ja.md.radius) ? (_ma = borderRadius[(_ka = props == null ? void 0 : props.hover) == null ? void 0 : _ka.md.radius]) != null ? _ma : (_la = props == null ? void 0 : props.hover) == null ? void 0 : _la.md.radius : void 0;
  if ((_pa = (_oa = (_na = mdHoverRadius == null ? void 0 : mdHoverRadius.topLeft) != null ? _na : mdHoverRadius == null ? void 0 : mdHoverRadius.topRight) != null ? _oa : mdHoverRadius == null ? void 0 : mdHoverRadius.bottomLeft) != null ? _pa : mdHoverRadius == null ? void 0 : mdHoverRadius.bottomRight) {
    if (typeof universalMdRadiusHoverValue !== "undefined") {
      style["--h-md-br"] = universalMdRadiusHoverValue;
      classNames += `md:hover:rounded-[var(--h-md-br)] `;
    } else {
      if (typeof (mdHoverRadius == null ? void 0 : mdHoverRadius.topLeft) !== "undefined") {
        style["--h-md-tl-br"] = (_qa = borderRadius[mdHoverRadius == null ? void 0 : mdHoverRadius.topLeft]) != null ? _qa : mdHoverRadius == null ? void 0 : mdHoverRadius.topLeft;
        classNames += `md:hover:rounded-tl-[var(--h-md-tl-br)] `;
      }
      if (typeof (mdHoverRadius == null ? void 0 : mdHoverRadius.topRight) !== "undefined") {
        style["--h-md-tr-br"] = (_ra = borderRadius[mdHoverRadius == null ? void 0 : mdHoverRadius.topRight]) != null ? _ra : mdHoverRadius == null ? void 0 : mdHoverRadius.topRight;
        classNames += `md:hover:rounded-tr-[var(--h-md-tr-br)] `;
      }
      if (typeof (mdHoverRadius == null ? void 0 : mdHoverRadius.bottomLeft) !== "undefined") {
        style["--h-md-bl-br"] = (_sa = borderRadius[mdHoverRadius == null ? void 0 : mdHoverRadius.bottomLeft]) != null ? _sa : mdHoverRadius == null ? void 0 : mdHoverRadius.bottomLeft;
        classNames += `md:hover:rounded-bl-[var(--h-md-bl-br)] `;
      }
      if (typeof (mdHoverRadius == null ? void 0 : mdHoverRadius.bottomRight) !== "undefined") {
        style["--h-md-br-br"] = (_ta = borderRadius[mdHoverRadius == null ? void 0 : mdHoverRadius.bottomRight]) != null ? _ta : mdHoverRadius == null ? void 0 : mdHoverRadius.bottomRight;
        classNames += `md:hover:rounded-br-[var(--h-md-br-br)] `;
      }
    }
  }
  const universalDRadiusHoverValue = ((_va = (_ua = props.hover) == null ? void 0 : _ua.d) == null ? void 0 : _va.radius) && isSingleRadius((_wa = props == null ? void 0 : props.hover) == null ? void 0 : _wa.d.radius) ? (_za = borderRadius[(_xa = props == null ? void 0 : props.hover) == null ? void 0 : _xa.d.radius]) != null ? _za : (_ya = props == null ? void 0 : props.hover) == null ? void 0 : _ya.d.radius : void 0;
  const mdHoverRadiusValue = universalMdRadiusHoverValue != null ? universalMdRadiusHoverValue : universalDRadiusHoverValue;
  if (typeof universalDRadiusHoverValue !== "undefined" && mdHoverRadiusValue !== universalDRadiusHoverValue) {
    style["--h-d-br"] = universalDRadiusHoverValue;
    classNames += `lg:hover:rounded-[var(--h-d-br)] `;
  } else if (typeof universalDRadiusHoverValue === "undefined") {
    if (typeof (dHoverRadius == null ? void 0 : dHoverRadius.topLeft) !== "undefined") {
      style["--h-d-tl-br"] = (_Aa = borderRadius[dHoverRadius == null ? void 0 : dHoverRadius.topLeft]) != null ? _Aa : dHoverRadius == null ? void 0 : dHoverRadius.topLeft;
      classNames += `lg:hover:rounded-tl-[var(--h-d-tl-br)] `;
    }
    if (typeof (dHoverRadius == null ? void 0 : dHoverRadius.topRight) !== "undefined") {
      style["--h-d-tr-br"] = (_Ba = borderRadius[dHoverRadius == null ? void 0 : dHoverRadius.topRight]) != null ? _Ba : dHoverRadius == null ? void 0 : dHoverRadius.topRight;
      classNames += `lg:hover:rounded-tr-[var(--h-d-tr-br)] `;
    }
    if (typeof (dHoverRadius == null ? void 0 : dHoverRadius.bottomLeft) !== "undefined") {
      style["--h-d-bl-br"] = (_Ca = borderRadius[dHoverRadius == null ? void 0 : dHoverRadius.bottomLeft]) != null ? _Ca : dHoverRadius == null ? void 0 : dHoverRadius.bottomLeft;
      classNames += `lg:hover:rounded-bl-[var(--h-d-bl-br)] `;
    }
    if (typeof (dHoverRadius == null ? void 0 : dHoverRadius.bottomRight) !== "undefined") {
      style["--h-d-br-br"] = (_Da = borderRadius[dHoverRadius == null ? void 0 : dHoverRadius.bottomRight]) != null ? _Da : dHoverRadius == null ? void 0 : dHoverRadius.bottomRight;
      classNames += `lg:hover:rounded-br-[var(--h-d-br-br)] `;
    }
  }
  const { colors } = useUiKitTheme();
  const m = ((_Ea = props.m) == null ? void 0 : _Ea.color) ? transformBorderColor((_Fa = props.m) == null ? void 0 : _Fa.color) : void 0;
  const md = ((_Ga = props.md) == null ? void 0 : _Ga.color) ? transformBorderColor((_Ha = props.md) == null ? void 0 : _Ha.color) : m;
  const d = ((_Ia = props.d) == null ? void 0 : _Ia.color) ? transformBorderColor((_Ja = props.d) == null ? void 0 : _Ja.color) : void 0;
  const mHover = ((_La = (_Ka = props == null ? void 0 : props.hover) == null ? void 0 : _Ka.m) == null ? void 0 : _La.color) ? transformBorderColor((_Na = (_Ma = props == null ? void 0 : props.hover) == null ? void 0 : _Ma.m) == null ? void 0 : _Na.color) : void 0;
  const mdHover = ((_Pa = (_Oa = props == null ? void 0 : props.hover) == null ? void 0 : _Oa.md) == null ? void 0 : _Pa.color) ? transformBorderColor((_Ra = (_Qa = props == null ? void 0 : props.hover) == null ? void 0 : _Qa.md) == null ? void 0 : _Ra.color) : mHover;
  const dHover = ((_Ta = (_Sa = props == null ? void 0 : props.hover) == null ? void 0 : _Sa.d) == null ? void 0 : _Ta.color) ? transformBorderColor((_Va = (_Ua = props == null ? void 0 : props.hover) == null ? void 0 : _Ua.d) == null ? void 0 : _Va.color) : void 0;
  if (typeof m !== "undefined") {
    classNames += "border ";
  }
  if (typeof md !== "undefined") {
    classNames += "md:border ";
  }
  if (typeof d !== "undefined") {
    classNames += "lg:border ";
  }
  if (typeof mHover !== "undefined") {
    classNames += "hover:border ";
  }
  if (typeof mdHover !== "undefined") {
    classNames += "md:hover:border ";
  }
  if (typeof dHover !== "undefined") {
    classNames += "lg:hover:border ";
  }
  const universalMColorValue = ((_Wa = props.m) == null ? void 0 : _Wa.color) && isSingleColor(props.m.color) ? props.m.color : void 0;
  if ((_Za = (_Ya = (_Xa = m == null ? void 0 : m.top) != null ? _Xa : m == null ? void 0 : m.left) != null ? _Ya : m == null ? void 0 : m.right) != null ? _Za : m == null ? void 0 : m.bottom) {
    if (universalMColorValue) {
      style["--b-color"] = (__a = colors[universalMColorValue]) != null ? __a : universalMColorValue;
      classNames += `[border-color:var(--b-color)] `;
    } else {
      if (m == null ? void 0 : m.top) {
        style["--top-b-color"] = (_$a = colors[m.top]) != null ? _$a : m.top;
        classNames += `[border-top-color:var(--top-b-color)] `;
      }
      if (m == null ? void 0 : m.bottom) {
        style["--bottom-b-color"] = (_ab = colors[m.bottom]) != null ? _ab : m.bottom;
        classNames += `[border-bottom-color:var(--bottom-b-color)] `;
      }
      if (m == null ? void 0 : m.left) {
        style["--bottom-l-color"] = (_bb = colors[m.left]) != null ? _bb : m.left;
        classNames += `[border-left-color:var(--bottom-l-color)] `;
      }
      if (m == null ? void 0 : m.right) {
        style["--bottom-r-color"] = (_cb = colors[m.right]) != null ? _cb : m.right;
        classNames += `[border-right-color:var(--bottom-r-color)] `;
      }
    }
  }
  const universalMdColorValue = ((_db = props.md) == null ? void 0 : _db.color) && isSingleColor(props.md.color) ? props.md.color : void 0;
  if ((_gb = (_fb = (_eb = md == null ? void 0 : md.top) != null ? _eb : md == null ? void 0 : md.left) != null ? _fb : md == null ? void 0 : md.right) != null ? _gb : md == null ? void 0 : md.bottom) {
    if (universalMdColorValue && universalMColorValue !== universalMdColorValue) {
      style["--md-b-color"] = (_hb = colors[universalMdColorValue]) != null ? _hb : universalMdColorValue;
      classNames += `md:[border-color:var(--md-b-color)] `;
    } else if (!universalMdColorValue) {
      if (md.top && md.top !== (m == null ? void 0 : m.top)) {
        style["--md-top-b-color"] = (_ib = colors[md.top]) != null ? _ib : md.top;
        classNames += `md:[border-top-color:var(--md-top-b-color)] `;
      }
      if (md.bottom && (md == null ? void 0 : md.bottom) !== (m == null ? void 0 : m.bottom)) {
        style["--md-bottom-b-color"] = (_jb = colors[md.bottom]) != null ? _jb : md.bottom;
        classNames += `md:[border-bottom-color:var(--md-bottom-b-color)] `;
      }
      if ((md == null ? void 0 : md.left) && (md == null ? void 0 : md.left) !== (m == null ? void 0 : m.left)) {
        style["--md-left-b-color"] = (_kb = colors[md.left]) != null ? _kb : md.left;
        classNames += `md:[border-left-color:var(--md-left-b-color)] `;
      }
      if ((md == null ? void 0 : md.right) && (md == null ? void 0 : md.right) !== (m == null ? void 0 : m.right)) {
        style["--md-right-b-color"] = (_lb = colors[md.right]) != null ? _lb : md.right;
        classNames += `md:[border-right-color:var(--md-right-b-color)] `;
      }
    }
  }
  const universalDValue = ((_mb = props.d) == null ? void 0 : _mb.color) && isSingleColor(props.d.color) ? props.d.color : void 0;
  const mdColorUniversal = universalMdColorValue != null ? universalMdColorValue : universalMColorValue;
  if (universalDValue && mdColorUniversal !== universalDValue) {
    style["--d-b-color"] = (_nb = colors[universalDValue]) != null ? _nb : universalDValue;
    classNames += `lg:[border-color:var(--d-b-color)] `;
  } else if (!universalDValue) {
    if ((d == null ? void 0 : d.top) && (d == null ? void 0 : d.top) !== (md == null ? void 0 : md.top)) {
      style["--d-top-b-color"] = (_ob = colors[d.top]) != null ? _ob : d.top;
      classNames += `lg:[border-top-color:var(--d-top-b-color)] `;
    }
    if ((d == null ? void 0 : d.bottom) && (d == null ? void 0 : d.bottom) !== (md == null ? void 0 : md.bottom)) {
      style["--d-bottom-b-color"] = (_pb = colors[d.bottom]) != null ? _pb : d.bottom;
      classNames += `lg:[border-bottom-color:var(--d-bottom-b-color)] `;
    }
    if ((d == null ? void 0 : d.left) && (d == null ? void 0 : d.left) !== (md == null ? void 0 : md.left)) {
      style["--d-left-b-color"] = (_qb = colors[d.left]) != null ? _qb : d.left;
      classNames += `lg:[border-left-color:var(--d-left-b-color)] `;
    }
    if ((d == null ? void 0 : d.right) && (d == null ? void 0 : d.right) !== (md == null ? void 0 : md.right)) {
      style["--d-right-b-color"] = (_rb = colors[d.right]) != null ? _rb : d.right;
      classNames += `lg:[border-right-color:var(--d-right-b-color)] `;
    }
  }
  const universalMHoverColorValue = ((_tb = (_sb = props == null ? void 0 : props.hover) == null ? void 0 : _sb.m) == null ? void 0 : _tb.color) && isSingleColor((_ub = props == null ? void 0 : props.hover) == null ? void 0 : _ub.m.color) ? (_vb = props == null ? void 0 : props.hover) == null ? void 0 : _vb.m.color : void 0;
  if ((_yb = (_xb = (_wb = mHover == null ? void 0 : mHover.top) != null ? _wb : mHover == null ? void 0 : mHover.left) != null ? _xb : mHover == null ? void 0 : mHover.right) != null ? _yb : mHover == null ? void 0 : mHover.bottom) {
    if (universalMHoverColorValue) {
      style["--hover-b-color"] = (_zb = colors[universalMHoverColorValue]) != null ? _zb : universalMHoverColorValue;
      classNames += `hover:[border-color:var(--hover-b-color)] `;
    } else {
      if (mHover == null ? void 0 : mHover.top) {
        style["--hover-top-b-color"] = (_Ab = colors[mHover.top]) != null ? _Ab : mHover.top;
        classNames += `hover:[border-top-color:var(--hover-top-b-color)] `;
      }
      if (mHover == null ? void 0 : mHover.bottom) {
        style["--hover-bottom-b-color"] = (_Bb = colors[mHover.bottom]) != null ? _Bb : mHover.bottom;
        classNames += `hover:[border-bottom-color:var(--hover-bottom-b-color)] `;
      }
      if (mHover == null ? void 0 : mHover.left) {
        style["--hover-left-b-color"] = (_Cb = colors[mHover.left]) != null ? _Cb : mHover.left;
        classNames += `hover:[border-left-color:var(--hover-left-b-color)] `;
      }
      if (mHover == null ? void 0 : mHover.right) {
        style["--hover-right-b-color"] = (_Db = colors[mHover.right]) != null ? _Db : mHover.right;
        classNames += `hover:[border-right-color:var(--hover-right-b-color)] `;
      }
    }
  }
  const universalMdHoverColorValue = ((_Fb = (_Eb = props == null ? void 0 : props.hover) == null ? void 0 : _Eb.md) == null ? void 0 : _Fb.color) && isSingleColor((_Gb = props == null ? void 0 : props.hover) == null ? void 0 : _Gb.md.color) ? (_Hb = props == null ? void 0 : props.hover) == null ? void 0 : _Hb.md.color : void 0;
  if ((_Kb = (_Jb = (_Ib = mdHover == null ? void 0 : mdHover.top) != null ? _Ib : mdHover == null ? void 0 : mdHover.left) != null ? _Jb : mdHover == null ? void 0 : mdHover.right) != null ? _Kb : mdHover == null ? void 0 : mdHover.bottom) {
    if (universalMdHoverColorValue && universalMHoverColorValue !== universalMdHoverColorValue) {
      style["--hover-md-b-color"] = (_Lb = colors[universalMdHoverColorValue]) != null ? _Lb : universalMdHoverColorValue;
      classNames += `hover:md:[border-color:var(--hover-md-b-color)] `;
    } else if (!universalMdHoverColorValue) {
      if (mdHover.top && mdHover.top !== (mHover == null ? void 0 : mHover.top)) {
        style["--hover-md-top-b-color"] = (_Mb = colors[mdHover.top]) != null ? _Mb : mdHover.top;
        classNames += `hover:md:[border-top-color:var(--hover-md-top-b-color)] `;
      }
      if (mdHover.bottom && (mdHover == null ? void 0 : mdHover.bottom) !== (mHover == null ? void 0 : mHover.bottom)) {
        style["--hover-md-bottom-b-color"] = (_Nb = colors[mdHover.bottom]) != null ? _Nb : mdHover.bottom;
        classNames += `hover:md:[border-bottom-color:var(--hover-md-bottom-b-color)] `;
      }
      if ((mdHover == null ? void 0 : mdHover.left) && (mdHover == null ? void 0 : mdHover.left) !== (mHover == null ? void 0 : mHover.left)) {
        style["--hover-md-left-b-color"] = (_Ob = colors[mdHover.left]) != null ? _Ob : mdHover.left;
        classNames += `hover:md:[border-left-color:var(--hover-md-left-b-color)] `;
      }
      if ((mdHover == null ? void 0 : mdHover.right) && (mdHover == null ? void 0 : mdHover.right) !== (mHover == null ? void 0 : mHover.right)) {
        style["--hover-md-right-b-color"] = (_Pb = colors[mdHover.right]) != null ? _Pb : mdHover.right;
        classNames += `hover:md:[border-right-color:var(--hover-md-right-b-color)] `;
      }
    }
  }
  const universalDHoverValue = ((_Rb = (_Qb = props == null ? void 0 : props.hover) == null ? void 0 : _Qb.d) == null ? void 0 : _Rb.color) && isSingleColor((_Sb = props == null ? void 0 : props.hover) == null ? void 0 : _Sb.d.color) ? (_Tb = props == null ? void 0 : props.hover) == null ? void 0 : _Tb.d.color : void 0;
  const mdHoverColorUniversal = universalMdHoverColorValue != null ? universalMdHoverColorValue : universalMHoverColorValue;
  if (universalDHoverValue && mdHoverColorUniversal !== universalDHoverValue) {
    style["--hover-d-b-color"] = (_Ub = colors[universalDHoverValue]) != null ? _Ub : universalDHoverValue;
    classNames += `hover:lg:[border-color:var(--hover-d-b-color)] `;
  } else if (!universalDHoverValue) {
    if ((dHover == null ? void 0 : dHover.top) && (dHover == null ? void 0 : dHover.top) !== (mdHover == null ? void 0 : mdHover.top)) {
      style["--hover-d-top-b-color"] = (_Vb = colors[dHover.top]) != null ? _Vb : dHover.top;
      classNames += `hover:lg:[border-top-color:var(--hover-d-top-b-color)] `;
    }
    if ((dHover == null ? void 0 : dHover.bottom) && (dHover == null ? void 0 : dHover.bottom) !== (mdHover == null ? void 0 : mdHover.bottom)) {
      style["--hover-d-bottom-b-color"] = (_Wb = colors[dHover.bottom]) != null ? _Wb : dHover.bottom;
      classNames += `hover:lg:[border-bottom-color:var(--hover-d-bottom-b-color)] `;
    }
    if ((dHover == null ? void 0 : dHover.left) && (dHover == null ? void 0 : dHover.left) !== (mdHover == null ? void 0 : mdHover.left)) {
      style["--hover-d-left-b-color"] = (_Xb = colors[dHover.left]) != null ? _Xb : dHover.left;
      classNames += `hover:lg:[border-left-color:var(--hover-d-left-b-color)] `;
    }
    if ((dHover == null ? void 0 : dHover.right) && (dHover == null ? void 0 : dHover.right) !== (mdHover == null ? void 0 : mdHover.right)) {
      style["--hover-d-right-b-color"] = (_Yb = colors[dHover.right]) != null ? _Yb : dHover.right;
      classNames += `hover:lg:[border-right-color:var(--hover-d-right-b-color)] `;
    }
  }
  const widthStyles = useBorderWidth(props);
  classNames += `${widthStyles.className} `;
  if ((_Zb = props.m) == null ? void 0 : _Zb.style) {
    classNames += `border-${props.m.style} `;
  }
  if (((__b = props.md) == null ? void 0 : __b.style) && props.md.style !== ((_$b = props.m) == null ? void 0 : _$b.style)) {
    classNames += `md:border-${props.md.style} `;
  }
  const mdStyle = (_cc = (_ac = props.md) == null ? void 0 : _ac.style) != null ? _cc : (_bc = props.m) == null ? void 0 : _bc.style;
  if (((_dc = props.d) == null ? void 0 : _dc.style) && props.d.style !== mdStyle) {
    classNames += `lg:border-${props.d.style} `;
  }
  return {
    className: classNames.trim(),
    style: { ...style, ...widthStyles.style }
  };
};
const useBoxShadow = (props, pseudoClass) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  if (!props) {
    return {
      style: {},
      className: ""
    };
  }
  const style = {};
  let className = "";
  const { colors } = useUiKitTheme();
  if ((_a = props.m) == null ? void 0 : _a.boxShadow) {
    style[`--box-${pseudoClass != null ? pseudoClass : ""}sh`] = (_d = colors[(_b = props.m) == null ? void 0 : _b.boxShadow]) != null ? _d : (_c = props.m) == null ? void 0 : _c.boxShadow;
    className += `${pseudoClass ? pseudoClass + ":" : ""}[box-shadow:var(--box-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  if (((_e = props.md) == null ? void 0 : _e.boxShadow) && ((_f = props.md) == null ? void 0 : _f.boxShadow) !== ((_g = props.m) == null ? void 0 : _g.boxShadow)) {
    style[`--md-box-${pseudoClass != null ? pseudoClass : ""}sh`] = (_j = colors[(_h = props.md) == null ? void 0 : _h.boxShadow]) != null ? _j : (_i = props.md) == null ? void 0 : _i.boxShadow;
    className += `md:${pseudoClass ? pseudoClass + ":" : ""}[box-shadow:var(--md-box-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  const mdShadow = (_m = (_k = props.md) == null ? void 0 : _k.boxShadow) != null ? _m : (_l = props.m) == null ? void 0 : _l.boxShadow;
  if (((_n = props == null ? void 0 : props.d) == null ? void 0 : _n.boxShadow) && ((_o = props.d) == null ? void 0 : _o.boxShadow) !== mdShadow) {
    style[`--d-box-${pseudoClass != null ? pseudoClass : ""}sh`] = (_r = colors[(_p = props.d) == null ? void 0 : _p.boxShadow]) != null ? _r : (_q = props.d) == null ? void 0 : _q.boxShadow;
    className += `lg:${pseudoClass ? pseudoClass + ":" : ""}[box-shadow:var(--d-box-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  return {
    style,
    className
  };
};
const useTextShadow = (props, pseudoClass) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  if (!props) {
    return {
      style: {},
      className: ""
    };
  }
  const style = {};
  let className = "";
  const { colors } = useUiKitTheme();
  if ((_a = props.m) == null ? void 0 : _a.textShadow) {
    style[`--text-${pseudoClass != null ? pseudoClass : ""}sh`] = (_d = colors[(_b = props.m) == null ? void 0 : _b.textShadow]) != null ? _d : (_c = props.m) == null ? void 0 : _c.textShadow;
    className += `${pseudoClass ? pseudoClass + ":" : ""}[text-shadow:var(--text-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  if (((_e = props.md) == null ? void 0 : _e.textShadow) && ((_f = props.md) == null ? void 0 : _f.boxShadow) !== ((_g = props.m) == null ? void 0 : _g.textShadow)) {
    style[`--md-text-${pseudoClass != null ? pseudoClass : ""}sh`] = (_j = colors[(_h = props.md) == null ? void 0 : _h.textShadow]) != null ? _j : (_i = props.md) == null ? void 0 : _i.textShadow;
    className += `md:${pseudoClass ? pseudoClass + ":" : ""}[text-shadow:var(--md-text-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  const mdShadow = (_m = (_k = props.md) == null ? void 0 : _k.textShadow) != null ? _m : (_l = props.m) == null ? void 0 : _l.textShadow;
  if (((_n = props == null ? void 0 : props.d) == null ? void 0 : _n.textShadow) && ((_o = props.d) == null ? void 0 : _o.boxShadow) !== mdShadow) {
    style[`--d-text-${pseudoClass != null ? pseudoClass : ""}sh`] = (_r = colors[(_p = props.d) == null ? void 0 : _p.textShadow]) != null ? _r : (_q = props.d) == null ? void 0 : _q.textShadow;
    className += `lg:${pseudoClass ? pseudoClass + ":" : ""}[text-shadow:var(--d-text-${pseudoClass != null ? pseudoClass : ""}sh)]`;
  }
  return {
    style,
    className
  };
};
const useOpacity = (props, pseudoClass) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!props) {
    return {
      style: {},
      className: ""
    };
  }
  const style = {};
  let className = "";
  if (typeof ((_a = props.m) == null ? void 0 : _a.opacity) !== "undefined") {
    style[`--opty-${pseudoClass != null ? pseudoClass : ""}d`] = (_b = props.m) == null ? void 0 : _b.opacity;
    className += `${pseudoClass ? pseudoClass + ":" : ""}[opacity:var(--opty-${pseudoClass != null ? pseudoClass : ""}d)] `;
  }
  if (typeof ((_c = props.md) == null ? void 0 : _c.opacity) !== "undefined" && props.md.opacity !== ((_d = props.m) == null ? void 0 : _d.opacity)) {
    style[`--md-opty-${pseudoClass != null ? pseudoClass : ""}d`] = props.md.opacity;
    className += `md:${pseudoClass ? pseudoClass + ":" : ""}[opacity:var(--md-opty-${pseudoClass != null ? pseudoClass : ""}d)] `;
  }
  const mdOpacity = (_g = (_e = props.md) == null ? void 0 : _e.opacity) != null ? _g : (_f = props.m) == null ? void 0 : _f.opacity;
  if (typeof ((_h = props.d) == null ? void 0 : _h.opacity) !== "undefined" && ((_i = props == null ? void 0 : props.d) == null ? void 0 : _i.opacity) !== mdOpacity) {
    style[`--d-opty-${pseudoClass != null ? pseudoClass : ""}d`] = props.d.opacity;
    className += `lg:${pseudoClass ? pseudoClass + ":" : ""}[opacity:var(--d-opty-${pseudoClass != null ? pseudoClass : ""}d)] `;
  }
  return {
    style,
    className
  };
};
const useOverflow = (props, pseudoClass) => {
  var _a, _b, _c, _d, _e, _f;
  if (!props) {
    return {
      style: {},
      className: ""
    };
  }
  const style = {};
  let className = "";
  if ((_a = props.m) == null ? void 0 : _a.overflow) {
    style[`--oflow-${pseudoClass != null ? pseudoClass : ""}ed`] = props.m.overflow;
    className += `${pseudoClass ? pseudoClass + ":" : ""}[overflow:var(--oflow-${pseudoClass != null ? pseudoClass : ""}ed)] `;
  }
  const baseOverflow = (_b = props.m) == null ? void 0 : _b.overflow;
  if (((_c = props.md) == null ? void 0 : _c.overflow) && props.md.overflow !== baseOverflow) {
    style[`--md-oflow-${pseudoClass != null ? pseudoClass : ""}ed`] = props.md.overflow;
    className += `md:${pseudoClass ? pseudoClass + ":" : ""}[overflow:var(--md-oflow-${pseudoClass != null ? pseudoClass : ""}ed)] `;
  }
  const mdOverflow = (_e = (_d = props.md) == null ? void 0 : _d.overflow) != null ? _e : baseOverflow;
  if (((_f = props.d) == null ? void 0 : _f.overflow) && props.d.overflow !== mdOverflow) {
    style[`--d-oflow-${pseudoClass != null ? pseudoClass : ""}ed`] = props.d.overflow;
    className += `lg:${pseudoClass ? pseudoClass + ":" : ""}[overflow:var(--d-oflow-${pseudoClass != null ? pseudoClass : ""}ed)] `;
  }
  return {
    style,
    className
  };
};
const useBackdropBlur = (props, pseudoClass) => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!props) {
    return {
      style: {},
      className: ""
    };
  }
  const style = {};
  let className = "";
  const formatValue = (val) => typeof val === "number" ? `${val}px` : val;
  if (((_a = props.m) == null ? void 0 : _a.backdropBlur) !== void 0) {
    style[`--bb-${pseudoClass != null ? pseudoClass : ""}l`] = formatValue(props.m.backdropBlur);
    className += `${pseudoClass ? pseudoClass + ":" : ""}[backdrop-filter:blur(var(--bb-${pseudoClass != null ? pseudoClass : ""}l))] `;
  }
  if (((_b = props.md) == null ? void 0 : _b.backdropBlur) !== void 0 && props.md.backdropBlur !== ((_c = props.m) == null ? void 0 : _c.backdropBlur)) {
    style[`--md-bb-${pseudoClass != null ? pseudoClass : ""}l`] = formatValue(props.md.backdropBlur);
    className += `md:${pseudoClass ? pseudoClass + ":" : ""}[backdrop-filter:blur(var(--md-bb-${pseudoClass != null ? pseudoClass : ""}l))] `;
  }
  const mdBlur = (_f = (_d = props.md) == null ? void 0 : _d.backdropBlur) != null ? _f : (_e = props.m) == null ? void 0 : _e.backdropBlur;
  if (((_g = props.d) == null ? void 0 : _g.backdropBlur) !== void 0 && props.d.backdropBlur !== mdBlur) {
    style[`--d-bb-${pseudoClass != null ? pseudoClass : ""}l`] = formatValue(props.d.backdropBlur);
    className += `lg:${pseudoClass ? pseudoClass + ":" : ""}[backdrop-filter:blur(var(--d-bb-${pseudoClass != null ? pseudoClass : ""}l))] `;
  }
  return { style, className };
};
const useCssEffects = (props) => {
  const boxShadow = useBoxShadow(props);
  const hoveredBoxShadow = useBoxShadow(props.hover, "hover");
  const textShadow = useTextShadow(props);
  const hoveredTextShadow = useTextShadow(props.hover, "hover");
  const opacity = useOpacity(props);
  const hoveredOpacity = useOpacity(props.hover, "hover");
  const overflow = useOverflow(props);
  const hoveredOverflow = useOverflow(props.hover, "hover");
  const backdropBlur = useBackdropBlur(props);
  const hoveredBackdropBlur = useBackdropBlur(props.hover, "hover");
  return {
    style: {
      ...boxShadow.style,
      ...hoveredBoxShadow.style,
      ...textShadow.style,
      ...hoveredTextShadow.style,
      ...opacity.style,
      ...hoveredOpacity.style,
      ...overflow.style,
      ...hoveredOverflow.style,
      ...backdropBlur.style,
      ...hoveredBackdropBlur.style
    },
    className: `${boxShadow.className} ${textShadow.className} ${hoveredBoxShadow.className} ${hoveredTextShadow.className} ${opacity.className} ${hoveredOpacity.className} ${overflow.className} ${hoveredOverflow.className} ${backdropBlur.className} ${hoveredBackdropBlur.className}`.trim()
  };
};
const useCursor = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  let className = "";
  const style = {};
  if ((_a = props.m) == null ? void 0 : _a.cursor) {
    className += `cursor-${props.m.cursor} `;
  }
  const mdCursor = (_d = (_b = props.md) == null ? void 0 : _b.cursor) != null ? _d : (_c = props.m) == null ? void 0 : _c.cursor;
  if (((_e = props.md) == null ? void 0 : _e.cursor) && props.md.cursor !== ((_f = props.m) == null ? void 0 : _f.cursor)) {
    className += `md:cursor-${props.md.cursor} `;
  }
  if (((_g = props.d) == null ? void 0 : _g.cursor) && props.d.cursor !== mdCursor) {
    className += `lg:cursor-${props.d.cursor} `;
  }
  return {
    className: className.trim(),
    style
  };
};
const useListStyle = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
  let className = "";
  const style = {};
  if ((_b = (_a = props.m) == null ? void 0 : _a.listStyle) == null ? void 0 : _b.type) {
    className += `list-${props.m.listStyle.type} `;
  }
  const mdType = (_g = (_d = (_c = props.md) == null ? void 0 : _c.listStyle) == null ? void 0 : _d.type) != null ? _g : (_f = (_e = props.m) == null ? void 0 : _e.listStyle) == null ? void 0 : _f.type;
  if (((_i = (_h = props.md) == null ? void 0 : _h.listStyle) == null ? void 0 : _i.type) && props.md.listStyle.type !== ((_k = (_j = props.m) == null ? void 0 : _j.listStyle) == null ? void 0 : _k.type)) {
    className += `md:list-${props.md.listStyle.type} `;
  }
  if (((_m = (_l = props.d) == null ? void 0 : _l.listStyle) == null ? void 0 : _m.type) && props.d.listStyle.type !== mdType) {
    className += `lg:list-${props.d.listStyle.type} `;
  }
  if ((_o = (_n = props.m) == null ? void 0 : _n.listStyle) == null ? void 0 : _o.position) {
    className += `list-${props.m.listStyle.position} `;
  }
  const mdPosition = (_t = (_q = (_p = props.md) == null ? void 0 : _p.listStyle) == null ? void 0 : _q.position) != null ? _t : (_s = (_r = props.m) == null ? void 0 : _r.listStyle) == null ? void 0 : _s.position;
  if (((_v = (_u = props.md) == null ? void 0 : _u.listStyle) == null ? void 0 : _v.position) && ((_w = props.md.listStyle) == null ? void 0 : _w.position) !== ((_y = (_x = props.m) == null ? void 0 : _x.listStyle) == null ? void 0 : _y.position)) {
    className += `md:list-${props.md.listStyle.position} `;
  }
  if (((_A = (_z = props.d) == null ? void 0 : _z.listStyle) == null ? void 0 : _A.position) && props.d.listStyle.position !== mdPosition) {
    className += `lg:list-${props.d.listStyle.position} `;
  }
  return {
    className: className.trim(),
    style
  };
};
const useOutline = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M;
  let className = "";
  const style = {};
  const { colors } = useUiKitTheme();
  let shouldAddOutlineClass = false;
  if ((_a = props.m) == null ? void 0 : _a.outlineColor) {
    style["--o-color"] = (_d = colors[(_b = props.m) == null ? void 0 : _b.outlineColor]) != null ? _d : (_c = props.m) == null ? void 0 : _c.outlineColor;
    className += `[outline-color:var(--o-color)] `;
    shouldAddOutlineClass = true;
  }
  if (((_e = props.md) == null ? void 0 : _e.outlineColor) && ((_f = props.m) == null ? void 0 : _f.outlineColor) !== ((_g = props.md) == null ? void 0 : _g.outlineColor)) {
    style["--md-o-color"] = (_h = colors[props.md.outlineColor]) != null ? _h : props.md.outlineColor;
    className += `md:[outline-color:var(--md-o-color)] `;
    shouldAddOutlineClass = true;
  }
  const mdOutlineColor = (_k = (_i = props == null ? void 0 : props.md) == null ? void 0 : _i.outlineColor) != null ? _k : (_j = props.m) == null ? void 0 : _j.outlineColor;
  if (((_l = props.d) == null ? void 0 : _l.outlineColor) && mdOutlineColor !== ((_m = props.d) == null ? void 0 : _m.outlineColor)) {
    style["--d-o-color"] = (_n = colors[props.d.outlineColor]) != null ? _n : props.d.outlineColor;
    className += `lg:[outline-color:var(--d-o-color)] `;
    shouldAddOutlineClass = true;
  }
  if ((_o = props.m) == null ? void 0 : _o.outlineWidth) {
    style["--o-width"] = (_p = props.m) == null ? void 0 : _p.outlineWidth;
    className += `[outline-width:var(--o-width)] `;
    shouldAddOutlineClass = true;
  }
  if ((_q = props.md) == null ? void 0 : _q.outlineWidth) {
    style["--md-o-width"] = props.md.outlineWidth;
    className += `md:[outline-width:var(--md-o-width)] `;
    shouldAddOutlineClass = true;
  }
  const mdOutline = (_t = (_r = props.md) == null ? void 0 : _r.outlineWidth) != null ? _t : (_s = props.m) == null ? void 0 : _s.outlineWidth;
  if (((_u = props.d) == null ? void 0 : _u.outlineWidth) && mdOutline !== ((_v = props.d) == null ? void 0 : _v.outlineWidth)) {
    style["--d-o-width"] = (_w = props.d) == null ? void 0 : _w.outlineWidth;
    className += `lg:[outline-width:var(--d-o-width)] `;
    shouldAddOutlineClass = true;
  }
  if ((_x = props.m) == null ? void 0 : _x.outlineOffset) {
    style["--o-offset"] = (_y = props.m) == null ? void 0 : _y.outlineOffset;
    className += `[outline-offset:var(--o-offset)] `;
    shouldAddOutlineClass = true;
  }
  if ((_z = props.md) == null ? void 0 : _z.outlineOffset) {
    style["--md-o-offset"] = props.md.outlineOffset;
    className += `md:[outline-offset:var(--md-o-offset)] `;
    shouldAddOutlineClass = true;
  }
  const mdOutlineOffset = (_C = (_A = props.md) == null ? void 0 : _A.outlineOffset) != null ? _C : (_B = props.m) == null ? void 0 : _B.outlineOffset;
  if (((_D = props.d) == null ? void 0 : _D.outlineOffset) && mdOutlineOffset !== ((_E = props.d) == null ? void 0 : _E.outlineOffset)) {
    style["--d-o-offset"] = (_F = props.d) == null ? void 0 : _F.outlineOffset;
    className += `lg:[outline-offset:var(--d-o-offset)] `;
    shouldAddOutlineClass = true;
  }
  if ((_G = props.m) == null ? void 0 : _G.outlineStyle) {
    className += `outline-${props.m.outlineStyle} `;
    shouldAddOutlineClass = true;
  }
  if ((_H = props.md) == null ? void 0 : _H.outlineStyle) {
    className += `md:outline-${props.md.outlineStyle} `;
    shouldAddOutlineClass = true;
  }
  const mdOutlineStyle = (_K = (_I = props.md) == null ? void 0 : _I.outlineStyle) != null ? _K : (_J = props.m) == null ? void 0 : _J.outlineStyle;
  if (((_L = props.d) == null ? void 0 : _L.outlineStyle) && mdOutlineStyle !== ((_M = props.d) == null ? void 0 : _M.outlineStyle)) {
    className += `lg:outline-${props.d.outlineStyle} `;
    shouldAddOutlineClass = true;
  }
  if (shouldAddOutlineClass) {
    className = "outline " + className;
  }
  return {
    className: className.trim(),
    style
  };
};
const useResolvedAttributes = (props) => {
  const resolvedProps = {};
  Object.entries(props).forEach(([key, value]) => {
    if (key.includes("aria-") || key.includes("data-")) {
      resolvedProps[key] = `${value}`;
    }
  });
  return resolvedProps;
};
const propertyTransformer = (value) => {
  return typeof value === "string" && !/^\d+$/.test(value) ? value : `${value}px`;
};
const isGradient = (value) => value.includes("gradient(");
const isImage = (value) => {
  return /\.(jpe?g|png|gif|webp|avif|svg|bmp|ico|tiff?)$/i.test(value) || /^(https?:\/\/)/.test(value);
};
const formatBackgroundValue = (value) => {
  if (!value) return "";
  if (isImage(value)) {
    return `url(${value})`;
  }
  return value;
};
const useBackground = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La, _Ma, _Na, _Oa, _Pa, _Qa, _Ra, _Sa, _Ta, _Ua, _Va, _Wa, _Xa, _Ya, _Za, __a, _$a, _ab, _bb, _cb, _db, _eb, _fb, _gb, _hb, _ib, _jb, _kb, _lb, _mb, _nb, _ob, _pb, _qb, _rb, _sb, _tb, _ub, _vb, _wb, _xb, _yb, _zb, _Ab, _Bb, _Cb, _Db, _Eb, _Fb, _Gb, _Hb, _Ib, _Jb, _Kb, _Lb, _Mb, _Nb, _Ob, _Pb, _Qb, _Rb, _Sb, _Tb, _Ub, _Vb, _Wb, _Xb, _Yb, _Zb, __b, _$b, _ac, _bc, _cc, _dc, _ec, _fc, _gc, _hc, _ic, _jc, _kc, _lc, _mc, _nc, _oc, _pc, _qc, _rc, _sc, _tc, _uc, _vc, _wc, _xc, _yc, _zc, _Ac, _Bc, _Cc, _Dc, _Ec, _Fc, _Gc, _Hc, _Ic, _Jc, _Kc, _Lc, _Mc, _Nc, _Oc, _Pc, _Qc, _Rc, _Sc, _Tc, _Uc, _Vc, _Wc, _Xc;
  const style = {};
  let className = "";
  const { colors } = useUiKitTheme();
  if ((_a = props == null ? void 0 : props.m) == null ? void 0 : _a.bg) {
    const value = (_d = colors[(_b = props == null ? void 0 : props.m) == null ? void 0 : _b.bg]) != null ? _d : (_c = props == null ? void 0 : props.m) == null ? void 0 : _c.bg;
    style["--bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "bg-[image:var(--bg)] " : "bg-[color:var(--bg)] ";
  }
  if (((_e = props == null ? void 0 : props.md) == null ? void 0 : _e.bg) && ((_f = props == null ? void 0 : props.m) == null ? void 0 : _f.bg) !== ((_g = props == null ? void 0 : props.md) == null ? void 0 : _g.bg)) {
    const value = (_j = colors[(_h = props == null ? void 0 : props.md) == null ? void 0 : _h.bg]) != null ? _j : (_i = props == null ? void 0 : props.md) == null ? void 0 : _i.bg;
    style["--md-bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "md:bg-[image:var(--md-bg)] " : "md:bg-none md:bg-[color:var(--md-bg)] ";
  }
  const mdValue = (_m = (_k = props == null ? void 0 : props.md) == null ? void 0 : _k.bg) != null ? _m : (_l = props == null ? void 0 : props.m) == null ? void 0 : _l.bg;
  if (((_n = props == null ? void 0 : props.d) == null ? void 0 : _n.bg) && ((_o = props == null ? void 0 : props.d) == null ? void 0 : _o.bg) !== mdValue) {
    const value = (_r = colors[(_p = props == null ? void 0 : props.d) == null ? void 0 : _p.bg]) != null ? _r : (_q = props == null ? void 0 : props.d) == null ? void 0 : _q.bg;
    style["--d-bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "lg:bg-[image:var(--d-bg)] " : "lg:bg-none lg:bg-[color:var(--d-bg)] ";
  }
  if ((_t = (_s = props == null ? void 0 : props.hover) == null ? void 0 : _s.m) == null ? void 0 : _t.bg) {
    const value = (_w = colors[(_u = props == null ? void 0 : props.hover) == null ? void 0 : _u.m.bg]) != null ? _w : (_v = props == null ? void 0 : props.hover) == null ? void 0 : _v.m.bg;
    style["--h-bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "hover:bg-[image:var(--h-bg)] " : "hover:bg-none hover:bg-[color:var(--h-bg)] ";
  }
  if (((_y = (_x = props == null ? void 0 : props.hover) == null ? void 0 : _x.md) == null ? void 0 : _y.bg) && ((_A = (_z = props == null ? void 0 : props.hover) == null ? void 0 : _z.md) == null ? void 0 : _A.bg) !== ((_C = (_B = props == null ? void 0 : props.hover) == null ? void 0 : _B.m) == null ? void 0 : _C.bg)) {
    const value = (_H = colors[(_E = (_D = props == null ? void 0 : props.hover) == null ? void 0 : _D.md) == null ? void 0 : _E.bg]) != null ? _H : (_G = (_F = props == null ? void 0 : props.hover) == null ? void 0 : _F.md) == null ? void 0 : _G.bg;
    style["--md-h-bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "md:hover:bg-[image:var(--md-h-bg)] " : "md:hover:bg-none md:hover:bg-[color:var(--md-h-bg)] ";
  }
  const mdHoverValue = (_M = (_J = (_I = props == null ? void 0 : props.hover) == null ? void 0 : _I.md) == null ? void 0 : _J.bg) != null ? _M : (_L = (_K = props == null ? void 0 : props.hover) == null ? void 0 : _K.m) == null ? void 0 : _L.bg;
  if (((_O = (_N = props == null ? void 0 : props.hover) == null ? void 0 : _N.d) == null ? void 0 : _O.bg) && ((_Q = (_P = props == null ? void 0 : props.hover) == null ? void 0 : _P.d) == null ? void 0 : _Q.bg) !== mdHoverValue) {
    const value = (_V = colors[(_S = (_R = props == null ? void 0 : props.hover) == null ? void 0 : _R.d) == null ? void 0 : _S.bg]) != null ? _V : (_U = (_T = props == null ? void 0 : props.hover) == null ? void 0 : _T.d) == null ? void 0 : _U.bg;
    style["--d-h-bg"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "lg:hover:bg-[image:var(--d-h-bg)] " : "lg:hover:bg-none lg:hover:bg-[color:var(--d-h-bg)] ";
  }
  if ((_X = (_W = props == null ? void 0 : props.hover) == null ? void 0 : _W.m) == null ? void 0 : _X.bgGroup) {
    const value = (__ = colors[(_Y = props == null ? void 0 : props.hover) == null ? void 0 : _Y.m.bgGroup]) != null ? __ : (_Z = props == null ? void 0 : props.hover) == null ? void 0 : _Z.m.bgGroup;
    style["--bg-group"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "group-hover:bg-[image:var(--bg-group)] " : "group-hover:bg-none hover:bg-none group-hover:bg-[color:var(--bg-group)] ";
  }
  if (((_aa = (_$ = props == null ? void 0 : props.hover) == null ? void 0 : _$.md) == null ? void 0 : _aa.bgGroup) && ((_ca = (_ba = props == null ? void 0 : props.hover) == null ? void 0 : _ba.md) == null ? void 0 : _ca.bgGroup) !== ((_ea = (_da = props == null ? void 0 : props.hover) == null ? void 0 : _da.m) == null ? void 0 : _ea.bgGroup)) {
    const value = (_ja = colors[(_ga = (_fa = props == null ? void 0 : props.hover) == null ? void 0 : _fa.md) == null ? void 0 : _ga.bgGroup]) != null ? _ja : (_ia = (_ha = props == null ? void 0 : props.hover) == null ? void 0 : _ha.md) == null ? void 0 : _ia.bgGroup;
    style["--md-bg-group"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "md:group-hover:bg-[image:var(--md-bg-group)] " : "md:group-hover:bg-none md:hover:bg-none md:group-hover:bg-[color:var(--md-bg-group)] ";
  }
  const mdGroupValue = (_oa = (_la = (_ka = props == null ? void 0 : props.hover) == null ? void 0 : _ka.md) == null ? void 0 : _la.bgGroup) != null ? _oa : (_na = (_ma = props == null ? void 0 : props.hover) == null ? void 0 : _ma.m) == null ? void 0 : _na.bgGroup;
  if (((_qa = (_pa = props == null ? void 0 : props.hover) == null ? void 0 : _pa.d) == null ? void 0 : _qa.bgGroup) && ((_sa = (_ra = props == null ? void 0 : props.hover) == null ? void 0 : _ra.d) == null ? void 0 : _sa.bgGroup) !== mdGroupValue) {
    const value = (_xa = colors[(_ua = (_ta = props == null ? void 0 : props.hover) == null ? void 0 : _ta.d) == null ? void 0 : _ua.bgGroup]) != null ? _xa : (_wa = (_va = props == null ? void 0 : props.hover) == null ? void 0 : _va.d) == null ? void 0 : _wa.bgGroup;
    style["--d-bg-group"] = formatBackgroundValue(value);
    className += isImage(value) || isGradient(value) ? "lg:group-hover:bg-[image:var(--d-bg-group)] " : "lg:group-hover:bg-none md:hover:bg-none lg:group-hover:bg-[color:var(--d-bg-group)] ";
  }
  if (!/bg-\[(?:color|image):var\(--[a-zA-Z0-9\-_]+\)\]/.test(className)) {
    return {
      className: "",
      style: {}
    };
  }
  if ((_ya = props == null ? void 0 : props.m) == null ? void 0 : _ya.bgRepeat) {
    className += `bg-${(_za = props == null ? void 0 : props.m) == null ? void 0 : _za.bgRepeat} `;
  }
  if (((_Aa = props == null ? void 0 : props.md) == null ? void 0 : _Aa.bgRepeat) && ((_Ba = props == null ? void 0 : props.m) == null ? void 0 : _Ba.bgRepeat) !== ((_Ca = props == null ? void 0 : props.md) == null ? void 0 : _Ca.bgRepeat)) {
    className += `md:bg-${(_Da = props == null ? void 0 : props.md) == null ? void 0 : _Da.bgRepeat} `;
  }
  const mdRepeat = (_Ga = (_Ea = props == null ? void 0 : props.md) == null ? void 0 : _Ea.bgRepeat) != null ? _Ga : (_Fa = props == null ? void 0 : props.m) == null ? void 0 : _Fa.bgRepeat;
  if (((_Ha = props == null ? void 0 : props.d) == null ? void 0 : _Ha.bgRepeat) && ((_Ia = props == null ? void 0 : props.d) == null ? void 0 : _Ia.bgRepeat) !== mdRepeat) {
    className += `lg:bg-${(_Ja = props == null ? void 0 : props.d) == null ? void 0 : _Ja.bgRepeat} `;
  }
  if (((_Ka = props == null ? void 0 : props.m) == null ? void 0 : _Ka.bgSize) !== void 0) {
    if (((_La = props == null ? void 0 : props.m) == null ? void 0 : _La.bgSize) === "auto" || ((_Ma = props == null ? void 0 : props.m) == null ? void 0 : _Ma.bgSize) === "cover" || ((_Na = props == null ? void 0 : props.m) == null ? void 0 : _Na.bgSize) === "contain") {
      className += `bg-${(_Oa = props == null ? void 0 : props.m) == null ? void 0 : _Oa.bgSize} `;
    } else {
      style["--bs"] = propertyTransformer((_Pa = props == null ? void 0 : props.m) == null ? void 0 : _Pa.bgSize);
      className += `bg-[length:var(--bs)] `;
    }
  }
  if (((_Qa = props == null ? void 0 : props.md) == null ? void 0 : _Qa.bgSize) !== void 0 && ((_Ra = props == null ? void 0 : props.md) == null ? void 0 : _Ra.bgSize) !== ((_Sa = props == null ? void 0 : props.m) == null ? void 0 : _Sa.bgSize)) {
    if (((_Ta = props == null ? void 0 : props.md) == null ? void 0 : _Ta.bgSize) === "auto" || ((_Ua = props == null ? void 0 : props.md) == null ? void 0 : _Ua.bgSize) === "cover" || ((_Va = props == null ? void 0 : props.md) == null ? void 0 : _Va.bgSize) === "contain") {
      className += `md:bg-${(_Wa = props == null ? void 0 : props.md) == null ? void 0 : _Wa.bgSize} `;
    } else {
      style["--md-bs"] = propertyTransformer((_Xa = props == null ? void 0 : props.md) == null ? void 0 : _Xa.bgSize);
      className += `md:bg-[length:var(--md-bs)] `;
    }
  }
  const mdSize = (__a = (_Ya = props == null ? void 0 : props.md) == null ? void 0 : _Ya.bgSize) != null ? __a : (_Za = props == null ? void 0 : props.m) == null ? void 0 : _Za.bgSize;
  if (((_$a = props == null ? void 0 : props.d) == null ? void 0 : _$a.bgSize) !== void 0 && ((_ab = props == null ? void 0 : props.d) == null ? void 0 : _ab.bgSize) !== mdSize) {
    if (((_bb = props == null ? void 0 : props.d) == null ? void 0 : _bb.bgSize) === "auto" || ((_cb = props == null ? void 0 : props.d) == null ? void 0 : _cb.bgSize) === "cover" || ((_db = props == null ? void 0 : props.d) == null ? void 0 : _db.bgSize) === "contain") {
      className += `lg:bg-${(_eb = props == null ? void 0 : props.d) == null ? void 0 : _eb.bgSize} `;
    } else {
      style["--d-bs"] = propertyTransformer((_fb = props == null ? void 0 : props.d) == null ? void 0 : _fb.bgSize);
      className += `lg:bg-[length:var(--d-bs)] `;
    }
  }
  if ((_gb = props == null ? void 0 : props.m) == null ? void 0 : _gb.bgPosition) {
    className += `bg-${(_hb = props == null ? void 0 : props.m) == null ? void 0 : _hb.bgPosition} `;
  }
  if (((_ib = props == null ? void 0 : props.md) == null ? void 0 : _ib.bgPosition) && ((_jb = props == null ? void 0 : props.m) == null ? void 0 : _jb.bgPosition) !== ((_kb = props == null ? void 0 : props.md) == null ? void 0 : _kb.bgPosition)) {
    className += `md:bg-${(_lb = props == null ? void 0 : props.md) == null ? void 0 : _lb.bgPosition} `;
  }
  const mdPosition = (_ob = (_mb = props == null ? void 0 : props.md) == null ? void 0 : _mb.bgPosition) != null ? _ob : (_nb = props == null ? void 0 : props.m) == null ? void 0 : _nb.bgPosition;
  if (((_pb = props == null ? void 0 : props.d) == null ? void 0 : _pb.bgPosition) && ((_qb = props == null ? void 0 : props.d) == null ? void 0 : _qb.bgPosition) !== mdPosition) {
    className += `lg:bg-${(_rb = props == null ? void 0 : props.d) == null ? void 0 : _rb.bgPosition} `;
  }
  if (((_tb = (_sb = props == null ? void 0 : props.hover) == null ? void 0 : _sb.m) == null ? void 0 : _tb.bgSize) !== void 0) {
    if (((_ub = props == null ? void 0 : props.hover) == null ? void 0 : _ub.m.bgSize) === "auto" || ((_vb = props == null ? void 0 : props.hover) == null ? void 0 : _vb.m.bgSize) === "cover" || ((_wb = props == null ? void 0 : props.hover) == null ? void 0 : _wb.m.bgSize) === "contain") {
      className += `hover:bg-${(_xb = props == null ? void 0 : props.hover) == null ? void 0 : _xb.m.bgSize} `;
    } else {
      style["--hover-m-bs"] = propertyTransformer((_yb = props == null ? void 0 : props.hover) == null ? void 0 : _yb.m.bgSize);
      className += `hover:bg-[length:var(--hover-m-bs)] `;
    }
  }
  if (((_Ab = (_zb = props == null ? void 0 : props.hover) == null ? void 0 : _zb.md) == null ? void 0 : _Ab.bgSize) !== void 0 && ((_Cb = (_Bb = props == null ? void 0 : props.hover) == null ? void 0 : _Bb.md) == null ? void 0 : _Cb.bgSize) !== ((_Eb = (_Db = props == null ? void 0 : props.hover) == null ? void 0 : _Db.m) == null ? void 0 : _Eb.bgSize)) {
    if (((_Gb = (_Fb = props == null ? void 0 : props.hover) == null ? void 0 : _Fb.md) == null ? void 0 : _Gb.bgSize) === "auto" || ((_Ib = (_Hb = props == null ? void 0 : props.hover) == null ? void 0 : _Hb.md) == null ? void 0 : _Ib.bgSize) === "cover" || ((_Kb = (_Jb = props == null ? void 0 : props.hover) == null ? void 0 : _Jb.md) == null ? void 0 : _Kb.bgSize) === "contain") {
      className += `md:hover:bg-${(_Mb = (_Lb = props == null ? void 0 : props.hover) == null ? void 0 : _Lb.md) == null ? void 0 : _Mb.bgSize} `;
    } else {
      style["--hover-md-bs"] = propertyTransformer((_Ob = (_Nb = props == null ? void 0 : props.hover) == null ? void 0 : _Nb.md) == null ? void 0 : _Ob.bgSize);
      className += `md:hover:bg-[length:var(--hover-md-bs)] `;
    }
  }
  const mdHoverSize = (_Tb = (_Qb = (_Pb = props == null ? void 0 : props.hover) == null ? void 0 : _Pb.md) == null ? void 0 : _Qb.bgSize) != null ? _Tb : (_Sb = (_Rb = props == null ? void 0 : props.hover) == null ? void 0 : _Rb.m) == null ? void 0 : _Sb.bgSize;
  if (((_Vb = (_Ub = props == null ? void 0 : props.hover) == null ? void 0 : _Ub.d) == null ? void 0 : _Vb.bgSize) !== void 0 && ((_Xb = (_Wb = props == null ? void 0 : props.hover) == null ? void 0 : _Wb.d) == null ? void 0 : _Xb.bgSize) !== mdHoverSize) {
    if (((_Zb = (_Yb = props == null ? void 0 : props.hover) == null ? void 0 : _Yb.d) == null ? void 0 : _Zb.bgSize) === "auto" || ((_$b = (__b = props == null ? void 0 : props.hover) == null ? void 0 : __b.d) == null ? void 0 : _$b.bgSize) === "cover" || ((_bc = (_ac = props == null ? void 0 : props.hover) == null ? void 0 : _ac.d) == null ? void 0 : _bc.bgSize) === "contain") {
      className += `lg:hover:bg-${(_dc = (_cc = props == null ? void 0 : props.hover) == null ? void 0 : _cc.d) == null ? void 0 : _dc.bgSize} `;
    } else {
      style["--hover-d-bs"] = propertyTransformer((_fc = (_ec = props == null ? void 0 : props.hover) == null ? void 0 : _ec.d) == null ? void 0 : _fc.bgSize);
      className += `lg:hover:bg-[length:var(--hover-d-bs)] `;
    }
  }
  if ((_hc = (_gc = props == null ? void 0 : props.hover) == null ? void 0 : _gc.m) == null ? void 0 : _hc.bgPosition) {
    className += `hover:bg-${(_ic = props == null ? void 0 : props.hover) == null ? void 0 : _ic.m.bgPosition} `;
  }
  if (((_kc = (_jc = props == null ? void 0 : props.hover) == null ? void 0 : _jc.md) == null ? void 0 : _kc.bgPosition) && ((_mc = (_lc = props == null ? void 0 : props.hover) == null ? void 0 : _lc.md) == null ? void 0 : _mc.bgPosition) !== ((_oc = (_nc = props == null ? void 0 : props.hover) == null ? void 0 : _nc.m) == null ? void 0 : _oc.bgPosition)) {
    className += `md:hover:bg-${(_qc = (_pc = props == null ? void 0 : props.hover) == null ? void 0 : _pc.md) == null ? void 0 : _qc.bgPosition} `;
  }
  const mdHoverPosition = (_vc = (_sc = (_rc = props == null ? void 0 : props.hover) == null ? void 0 : _rc.md) == null ? void 0 : _sc.bgPosition) != null ? _vc : (_uc = (_tc = props == null ? void 0 : props.hover) == null ? void 0 : _tc.m) == null ? void 0 : _uc.bgPosition;
  if (((_xc = (_wc = props == null ? void 0 : props.hover) == null ? void 0 : _wc.d) == null ? void 0 : _xc.bgPosition) && ((_zc = (_yc = props == null ? void 0 : props.hover) == null ? void 0 : _yc.d) == null ? void 0 : _zc.bgPosition) !== mdHoverPosition) {
    className += `lg:hover:bg-${(_Bc = (_Ac = props == null ? void 0 : props.hover) == null ? void 0 : _Ac.d) == null ? void 0 : _Bc.bgPosition} `;
  }
  if ((_Dc = (_Cc = props == null ? void 0 : props.hover) == null ? void 0 : _Cc.m) == null ? void 0 : _Dc.bgRepeat) {
    className += `hover:bg-${(_Ec = props == null ? void 0 : props.hover) == null ? void 0 : _Ec.m.bgRepeat} `;
  }
  if (((_Gc = (_Fc = props == null ? void 0 : props.hover) == null ? void 0 : _Fc.md) == null ? void 0 : _Gc.bgRepeat) && ((_Ic = (_Hc = props == null ? void 0 : props.hover) == null ? void 0 : _Hc.md) == null ? void 0 : _Ic.bgRepeat) !== ((_Kc = (_Jc = props == null ? void 0 : props.hover) == null ? void 0 : _Jc.m) == null ? void 0 : _Kc.bgRepeat)) {
    className += `md:hover:bg-${(_Mc = (_Lc = props == null ? void 0 : props.hover) == null ? void 0 : _Lc.md) == null ? void 0 : _Mc.bgRepeat} `;
  }
  const mdHoverRepeat = (_Rc = (_Oc = (_Nc = props == null ? void 0 : props.hover) == null ? void 0 : _Nc.md) == null ? void 0 : _Oc.bgRepeat) != null ? _Rc : (_Qc = (_Pc = props == null ? void 0 : props.hover) == null ? void 0 : _Pc.m) == null ? void 0 : _Qc.bgRepeat;
  if (((_Tc = (_Sc = props == null ? void 0 : props.hover) == null ? void 0 : _Sc.d) == null ? void 0 : _Tc.bgRepeat) && ((_Vc = (_Uc = props == null ? void 0 : props.hover) == null ? void 0 : _Uc.d) == null ? void 0 : _Vc.bgRepeat) !== mdHoverRepeat) {
    className += `lg:hover:bg-${(_Xc = (_Wc = props == null ? void 0 : props.hover) == null ? void 0 : _Wc.d) == null ? void 0 : _Xc.bgRepeat} `;
  }
  return {
    className,
    style
  };
};
const useDimensions = ({
  m,
  md,
  d
}) => {
  let className = "";
  const styles = {};
  if (m) {
    if (typeof m.width !== "undefined") {
      styles["--width"] = typeof m.width !== "string" ? m.width + "px" : m.width;
      className += `w-[var(--width)] `;
    }
    if (typeof m.minWidth !== "undefined") {
      styles["--minWidth"] = typeof m.minWidth !== "string" ? m.minWidth + "px" : m.minWidth;
      className += `min-w-[var(--minWidth)] `;
    }
    if (typeof m.maxWidth !== "undefined") {
      styles["--maxWidth"] = typeof m.maxWidth !== "string" ? m.maxWidth + "px" : m.maxWidth;
      className += `max-w-[var(--maxWidth)] `;
    }
    if (typeof m.height !== "undefined") {
      styles["--height"] = typeof m.height !== "string" ? m.height + "px" : m.height;
      className += `h-[var(--height)] `;
    }
    if (typeof m.minHeight !== "undefined") {
      styles["--minHeight"] = typeof m.minHeight !== "string" ? m.minHeight + "px" : m.minHeight;
      className += `min-h-[var(--minHeight)] `;
    }
    if (typeof m.maxHeight !== "undefined") {
      styles["--maxHeight"] = typeof m.maxHeight !== "string" ? m.maxHeight + "px" : m.maxHeight;
      className += `max-h-[var(--maxHeight)] `;
    }
  }
  ({
    width: m == null ? void 0 : m.width,
    maxWidth: m == null ? void 0 : m.maxWidth,
    minWidth: m == null ? void 0 : m.minWidth,
    height: m == null ? void 0 : m.height,
    minHeight: m == null ? void 0 : m.minHeight,
    maxHeight: m == null ? void 0 : m.maxHeight
  });
  if (md) {
    if (typeof md.width !== "undefined") {
      if ((m == null ? void 0 : m.width) !== md.width) {
        styles["--mdWidth"] = typeof md.width !== "string" ? md.width + "px" : md.width;
        className += `md:w-[var(--mdWidth)] `;
      }
      md.width;
    }
    if (typeof md.minWidth !== "undefined") {
      if ((m == null ? void 0 : m.minWidth) !== md.minWidth) {
        styles["--mdMinWidth"] = typeof md.minWidth !== "string" ? md.minWidth + "px" : md.minWidth;
        className += `md:min-w-[var(--mdMinWidth)] `;
      }
      md.minWidth;
    }
    if (typeof md.maxWidth !== "undefined") {
      if ((m == null ? void 0 : m.maxWidth) !== md.maxWidth) {
        styles["--mdMaxWidth"] = typeof md.maxWidth !== "string" ? md.maxWidth + "px" : md.maxWidth;
        className += `md:max-w-[var(--mdMaxWidth)] `;
      }
      md.maxWidth;
    }
    if (typeof md.height !== "undefined") {
      if ((m == null ? void 0 : m.height) !== md.height) {
        styles["--mdHeight"] = typeof md.height !== "string" ? md.height + "px" : md.height;
        className += `md:h-[var(--mdHeight)] `;
      }
      md.height;
    }
    if (typeof md.minHeight !== "undefined") {
      if ((m == null ? void 0 : m.minHeight) !== md.minHeight) {
        styles["--mdMinHeight"] = typeof md.minHeight !== "string" ? md.minHeight + "px" : md.minHeight;
        className += `md:min-h-[var(--mdMinHeight)] `;
      }
      md.minHeight;
    }
    if (typeof md.maxHeight !== "undefined") {
      if ((m == null ? void 0 : m.maxHeight) !== md.maxHeight) {
        styles["--mdMaxHeight"] = typeof md.maxHeight !== "string" ? md.maxHeight + "px" : md.maxHeight;
        className += `md:max-h-[var(--mdMaxHeight)] `;
      }
      md.maxHeight;
    }
  }
  if (d) {
    if (typeof d.width !== "undefined") {
      if ((md == null ? void 0 : md.width) !== d.width) {
        styles["--dWidth"] = typeof d.width !== "string" ? d.width + "px" : d.width;
        className += `lg:w-[var(--dWidth)] `;
      }
      d.width;
    }
    if (typeof d.minWidth !== "undefined") {
      if ((md == null ? void 0 : md.minWidth) !== d.minWidth) {
        styles["--dMinWidth"] = typeof d.minWidth !== "string" ? d.minWidth + "px" : d.minWidth;
        className += `lg:min-w-[var(--dMinWidth)] `;
      }
      d.minWidth;
    }
    if (typeof d.maxWidth !== "undefined") {
      if ((md == null ? void 0 : md.maxWidth) !== d.maxWidth) {
        styles["--dMaxWidth"] = typeof d.maxWidth !== "string" ? d.maxWidth + "px" : d.maxWidth;
        className += `lg:max-w-[var(--dMaxWidth)] `;
      }
      d.maxWidth;
    }
    if (typeof d.height !== "undefined") {
      if ((md == null ? void 0 : md.height) !== d.height) {
        styles["--dHeight"] = typeof d.height !== "string" ? d.height + "px" : d.height;
        className += `lg:h-[var(--dHeight)] `;
      }
      d.height;
    }
    if (typeof d.minHeight !== "undefined") {
      if ((md == null ? void 0 : md.minHeight) !== d.minHeight) {
        styles["--dMinHeight"] = typeof d.minHeight !== "string" ? d.minHeight + "px" : d.minHeight;
        className += `lg:min-h-[var(--dMinHeight)] `;
      }
      d.minHeight;
    }
    if (typeof d.maxHeight !== "undefined") {
      if ((md == null ? void 0 : md.maxHeight) !== d.maxHeight) {
        styles["--dMaxHeight"] = typeof d.maxHeight !== "string" ? d.maxHeight + "px" : d.maxHeight;
        className += `lg:max-h-[var(--dMaxHeight)] `;
      }
      d.maxHeight;
    }
  }
  return {
    styles,
    className
  };
};
const useDisplay = (props) => {
  var _a;
  let classNames = "";
  if (props.m.display) {
    classNames += `${props.m.display} `;
  }
  if (props.md.display && props.m.display !== props.md.display) {
    classNames += `md:${props.md.display} `;
  }
  const mdValue = (_a = props.md.display) != null ? _a : props.m.display;
  if (props.d.display && props.d.display !== mdValue) {
    classNames += `lg:${props.d.display} `;
  }
  return {
    classNames
  };
};
const usePosition = ({
  m,
  d,
  md
}) => {
  let className = "";
  const styles = {};
  if (m) {
    if (m.position.type) {
      className += `${m.position.type} `;
    }
    if (typeof m.position.top !== "undefined") {
      styles["--mPositionTop"] = typeof m.position.top !== "string" ? m.position.top + "px" : m.position.top;
      className += `top-[var(--mPositionTop)] `;
    }
    if (typeof m.position.bottom !== "undefined") {
      styles["--mPositionBottom"] = typeof m.position.bottom !== "string" ? m.position.bottom + "px" : m.position.bottom;
      className += `bottom-[var(--mPositionBottom)] `;
    }
    if (typeof m.position.right !== "undefined") {
      styles["--mPositionRight"] = typeof m.position.right !== "string" ? m.position.right + "px" : m.position.right;
      className += `right-[var(--mPositionRight)] `;
    }
    if (typeof m.position.left !== "undefined") {
      styles["--mPositionLeft"] = typeof m.position.left !== "string" ? m.position.left + "px" : m.position.left;
      className += `left-[var(--mPositionLeft)] `;
    }
    if (typeof m.position.zIndex !== "undefined") {
      styles["--mPositionZ"] = String(m.position.zIndex);
      className += `z-[var(--mPositionZ)] `;
    }
  }
  const mdCalculatedValues = {
    position: {
      ...m == null ? void 0 : m.position
    }
  };
  if (md) {
    if (md.position.type) {
      if ((m == null ? void 0 : m.position.type) !== md.position.type) {
        className += `md:${md.position.type} `;
      }
      mdCalculatedValues.position.type = md.position.type;
    }
    if (typeof md.position.top !== "undefined") {
      if ((m == null ? void 0 : m.position.top) !== md.position.top) {
        styles["--mdPositionTop"] = typeof md.position.top !== "string" ? md.position.top + "px" : md.position.top;
        className += `md:top-[var(--mdPositionTop)] `;
      }
      mdCalculatedValues.position.top = md.position.top;
    }
    if (typeof md.position.bottom !== "undefined") {
      if ((m == null ? void 0 : m.position.bottom) !== md.position.bottom) {
        styles["--mdPositionBottom"] = typeof md.position.bottom !== "string" ? md.position.bottom + "px" : md.position.bottom;
        className += `md:bottom-[var(--mdPositionBottom)] `;
      }
      mdCalculatedValues.position.bottom = md.position.bottom;
    }
    if (typeof md.position.right !== "undefined") {
      if ((m == null ? void 0 : m.position.right) !== md.position.right) {
        styles["--mdPositionRight"] = typeof md.position.right !== "string" ? md.position.right + "px" : md.position.right;
        className += `md:right-[var(--mdPositionRight)] `;
      }
      mdCalculatedValues.position.right = md.position.right;
    }
    if (typeof md.position.left !== "undefined") {
      if ((m == null ? void 0 : m.position.left) !== md.position.left) {
        styles["--mdPositionLeft"] = typeof md.position.left !== "string" ? md.position.left + "px" : md.position.left;
        className += `md:left-[var(--mdPositionLeft)] `;
      }
      mdCalculatedValues.position.left = md.position.left;
    }
    if (md.position.zIndex) {
      if ((m == null ? void 0 : m.position.zIndex) !== md.position.zIndex) {
        styles["--mdPositionZ"] = String(md.position.zIndex);
        className += `md:z-[var(--mdPositionZ)] `;
      }
      mdCalculatedValues.position.zIndex = md.position.zIndex;
    }
  }
  if (d) {
    if (d.position.type) {
      className += `lg:${d.position.type} `;
    }
    if (typeof d.position.top !== "undefined" && mdCalculatedValues.position.top !== d.position.top) {
      styles["--dPositionTop"] = typeof d.position.top !== "string" ? d.position.top + "px" : d.position.top;
      className += `lg:top-[var(--dPositionTop)] `;
    }
    if (typeof d.position.bottom !== "undefined" && mdCalculatedValues.position.bottom !== d.position.bottom) {
      styles["--dPositionBottom"] = typeof d.position.bottom !== "string" ? d.position.bottom + "px" : d.position.bottom;
      className += `lg:bottom-[var(--dPositionBottom)] `;
    }
    if (typeof d.position.right !== "undefined" && mdCalculatedValues.position.right !== d.position.right) {
      styles["--dPositionRight"] = typeof d.position.right !== "string" ? d.position.right + "px" : d.position.right;
      className += `lg:right-[var(--dPositionRight)] `;
    }
    if (typeof d.position.left !== "undefined" && mdCalculatedValues.position.left !== d.position.left) {
      styles["--dPositionLeft"] = typeof d.position.left !== "string" ? d.position.left + "px" : d.position.left;
      className += `lg:left-[var(--dPositionLeft)] `;
    }
    if (d.position.zIndex && mdCalculatedValues.position.zIndex !== d.position.zIndex) {
      styles["--dPositionZ"] = String(d.position.zIndex);
      className += `lg:z-[var(--dPositionZ)] `;
    }
  }
  return {
    styles,
    className
  };
};
const isSinglePadding = (entry) => {
  return typeof entry === "number";
};
const isArrayPadding = (entry) => {
  return Array.isArray(entry);
};
const isAxisDirectionPadding = (entry) => {
  return typeof entry === "object" && ("px" in entry || "py" in entry) && !("pb" in entry) && !("pt" in entry) && !("pr" in entry) && !("pl" in entry);
};
const isMixedXAxisIndentationPadding = (entry) => {
  return typeof entry === "object" && "px" in entry && ("pt" in entry || "pb" in entry) && !("pr" in entry) && !("pl" in entry);
};
const isMixedYAxisIndentationPadding = (entry) => {
  return typeof entry === "object" && "py" in entry && ("pl" in entry || "pr" in entry) && !("pt" in entry) && !("pb" in entry);
};
const isMixedXAxisIndentationMargin = (entry) => {
  return typeof entry === "object" && "mx" in entry && ("mt" in entry || "mb" in entry) && !("mr" in entry) && !("ml" in entry);
};
const isMixedYAxisIndentationMargin = (entry) => {
  return typeof entry === "object" && "my" in entry && ("ml" in entry || "mr" in entry) && !("mt" in entry) && !("mb" in entry);
};
const isAnyDirectionPadding = (entry) => {
  return typeof entry === "object" && ("pt" in entry || "pb" in entry || "pr" in entry || "pl" in entry) && !("py" in entry) && !("px" in entry);
};
const isSingleMargin = (entry) => {
  return typeof entry === "number";
};
const isArrayMargin = (entry) => {
  return Array.isArray(entry);
};
const isAxisDirectionMargin = (entry) => {
  return typeof entry === "object" && ("mx" in entry || "my" in entry) && !("mb" in entry) && !("mt" in entry) && !("mr" in entry) && !("ml" in entry);
};
const isAnyDirectionMargin = (entry) => {
  return typeof entry === "object" && ("mt" in entry || "mb" in entry || "mr" in entry || "ml" in entry) && !("my" in entry) && !("mx" in entry);
};
const getIndentationsStyles = (params, fallbackSpacing, prev) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const padding = [
    (prev == null ? void 0 : prev.padding) ? prev.padding[0] : ((_a = fallbackSpacing == null ? void 0 : fallbackSpacing.padding) == null ? void 0 : _a[0]) ? fallbackSpacing.padding[0] + "px" : "0px",
    (prev == null ? void 0 : prev.padding) ? prev.padding[1] : ((_b = fallbackSpacing == null ? void 0 : fallbackSpacing.padding) == null ? void 0 : _b[1]) ? fallbackSpacing.padding[1] + "px" : "0px",
    (prev == null ? void 0 : prev.padding) ? prev.padding[2] : ((_c = fallbackSpacing == null ? void 0 : fallbackSpacing.padding) == null ? void 0 : _c[2]) ? fallbackSpacing.padding[2] + "px" : "0px",
    (prev == null ? void 0 : prev.padding) ? prev.padding[3] : ((_d = fallbackSpacing == null ? void 0 : fallbackSpacing.padding) == null ? void 0 : _d[3]) ? fallbackSpacing.padding[3] + "px" : "0px"
  ];
  if (params.p) {
    if (isAnyDirectionPadding(params.p)) {
      if (params.p.pt !== void 0) {
        padding[0] = params.p.pt + "px";
      }
      if (params.p.pr !== void 0) {
        padding[1] = params.p.pr + "px";
      }
      if (params.p.pb !== void 0) {
        padding[2] = params.p.pb + "px";
      }
      if (params.p.pl !== void 0) {
        padding[3] = params.p.pl + "px";
      }
    }
    if (isAxisDirectionPadding(params.p)) {
      if (params.p.py !== void 0) {
        const value = params.p.py + "px";
        padding[0] = value;
        padding[2] = value;
      }
      if (params.p.px !== void 0) {
        const value = params.p.px + "px";
        padding[1] = value;
        padding[3] = value;
      }
    }
    if (isArrayPadding(params.p)) {
      padding[0] = params.p[0] + "px";
      padding[1] = params.p[1] + "px";
      padding[2] = params.p[2] + "px";
      padding[3] = params.p[3] + "px";
    }
    if (isSinglePadding(params.p)) {
      const value = params.p + "px";
      padding[0] = value;
      padding[1] = value;
      padding[2] = value;
      padding[3] = value;
    }
    if (isMixedXAxisIndentationPadding(params.p)) {
      const value = params.p.px + "px";
      padding[1] = value;
      padding[3] = value;
      if (params.p.pt !== void 0) {
        padding[0] = params.p.pt + "px";
      }
      if (params.p.pb !== void 0) {
        padding[2] = params.p.pb + "px";
      }
    }
    if (isMixedYAxisIndentationPadding(params.p)) {
      const value = params.p.py + "px";
      padding[0] = value;
      padding[2] = value;
      if (params.p.pr !== void 0) {
        padding[1] = params.p.pr + "px";
      }
      if (params.p.pl !== void 0) {
        padding[3] = params.p.pl + "px";
      }
    }
  }
  const margin = [
    (prev == null ? void 0 : prev.margin) ? prev.margin[0] : ((_e = fallbackSpacing == null ? void 0 : fallbackSpacing.margin) == null ? void 0 : _e[0]) ? fallbackSpacing.margin[0] === "auto" ? fallbackSpacing.margin[0] : fallbackSpacing.margin[0] + "px" : "0px",
    (prev == null ? void 0 : prev.margin) ? prev.margin[1] : ((_f = fallbackSpacing == null ? void 0 : fallbackSpacing.margin) == null ? void 0 : _f[1]) ? fallbackSpacing.margin[1] === "auto" ? fallbackSpacing.margin[1] : fallbackSpacing.margin[1] + "px" : "0px",
    (prev == null ? void 0 : prev.margin) ? prev.margin[2] : ((_g = fallbackSpacing == null ? void 0 : fallbackSpacing.margin) == null ? void 0 : _g[2]) ? fallbackSpacing.margin[2] === "auto" ? fallbackSpacing.margin[2] : fallbackSpacing.margin[2] + "px" : "0px",
    (prev == null ? void 0 : prev.margin) ? prev.margin[3] : ((_h = fallbackSpacing == null ? void 0 : fallbackSpacing.margin) == null ? void 0 : _h[3]) ? fallbackSpacing.margin[3] === "auto" ? fallbackSpacing.margin[3] : fallbackSpacing.margin[3] + "px" : "0px"
  ];
  if (params.m) {
    if (isAnyDirectionMargin(params.m)) {
      if (params.m.mt !== void 0) {
        margin[0] = params.m.mt === "auto" ? params.m.mt : params.m.mt + "px";
      }
      if (params.m.mr !== void 0) {
        margin[1] = params.m.mr === "auto" ? params.m.mr : params.m.mr + "px";
      }
      if (params.m.mb !== void 0) {
        margin[2] = params.m.mb === "auto" ? params.m.mb : params.m.mb + "px";
      }
      if (params.m.ml !== void 0) {
        margin[3] = params.m.ml === "auto" ? params.m.ml : params.m.ml + "px";
      }
    }
    if (isAxisDirectionMargin(params.m)) {
      if (params.m.my !== void 0) {
        const value = params.m.my === "auto" ? params.m.my : params.m.my + "px";
        margin[0] = value;
        margin[2] = value;
      }
      if (params.m.mx !== void 0) {
        const value = params.m.mx === "auto" ? params.m.mx : params.m.mx + "px";
        margin[1] = value;
        margin[3] = value;
      }
    }
    if (isMixedXAxisIndentationMargin(params.m)) {
      const value = params.m.mx === "auto" ? params.m.mx : params.m.mx + "px";
      margin[1] = value;
      margin[3] = value;
      if (params.m.mt !== void 0) {
        margin[0] = params.m.mt === "auto" ? params.m.mt : params.m.mt + "px";
      }
      if (params.m.mb !== void 0) {
        margin[2] = params.m.mb === "auto" ? params.m.mb : params.m.mb + "px";
      }
    }
    if (isMixedYAxisIndentationMargin(params.m)) {
      const value = params.m.my === "auto" ? params.m.my : params.m.my + "px";
      margin[0] = value;
      margin[2] = value;
      if (params.m.mr !== void 0) {
        margin[1] = params.m.mr === "auto" ? params.m.mr : params.m.mr + "px";
      }
      if (params.m.ml !== void 0) {
        margin[3] = params.m.ml === "auto" ? params.m.ml : params.m.ml + "px";
      }
    }
    if (isArrayMargin(params.m)) {
      margin[0] = params.m[0] === "auto" ? params.m[0] : params.m[0] + "px";
      margin[1] = params.m[1] === "auto" ? params.m[1] : params.m[1] + "px";
      margin[2] = params.m[2] === "auto" ? params.m[2] : params.m[2] + "px";
      margin[3] = params.m[3] === "auto" ? params.m[3] : params.m[3] + "px";
    }
    if (isSingleMargin(params.m)) {
      const value = params.m === "auto" ? params.m : params.m + "px";
      margin[0] = value;
      margin[1] = value;
      margin[2] = value;
      margin[3] = value;
    }
  }
  return { padding, margin };
};
const useSpacing = (params) => {
  var _a, _b;
  const md = params.md;
  const d = params == null ? void 0 : params.d;
  const mobileSpacing = getIndentationsStyles(
    { ...params.m },
    {
      padding: (_a = params.defaultPadding) != null ? _a : [0, 0, 0, 0],
      margin: (_b = params.defaultMargin) != null ? _b : [0, 0, 0, 0]
    }
  );
  const mdSpacing = md ? getIndentationsStyles({ ...md }, void 0, mobileSpacing) : mobileSpacing;
  const dSpacing = d ? getIndentationsStyles({ ...d }, void 0, mdSpacing) : mdSpacing;
  const styles = {};
  let className = "";
  if (JSON.stringify(mobileSpacing.padding) !== '["0px","0px","0px","0px"]') {
    if (mobileSpacing.padding[0] !== "0px") {
      styles["--m-pt"] = mobileSpacing.padding[0];
      className += `pt-[var(--m-pt)] `;
    }
    if (mobileSpacing.padding[2] !== "0px") {
      styles["--m-pb"] = mobileSpacing.padding[2];
      className += `pb-[var(--m-pb)] `;
    }
    if (mobileSpacing.padding[1] !== "0px") {
      styles["--m-pr"] = mobileSpacing.padding[1];
      className += `pr-[var(--m-pr)] `;
    }
    if (mobileSpacing.padding[3] !== "0px") {
      styles["--m-pl"] = mobileSpacing.padding[3];
      className += `pl-[var(--m-pl)] `;
    }
  }
  if (JSON.stringify(mdSpacing.padding) !== JSON.stringify(mobileSpacing.padding)) {
    if (mdSpacing.padding[0] !== mobileSpacing.padding[0]) {
      styles["--md-pt"] = mdSpacing.padding[0];
      className += `md:pt-[var(--md-pt)] `;
    }
    if (mdSpacing.padding[2] !== mobileSpacing.padding[2]) {
      styles["--md-pb"] = mdSpacing.padding[2];
      className += `md:pb-[var(--md-pb)] `;
    }
    if (mdSpacing.padding[1] !== mobileSpacing.padding[1]) {
      styles["--md-pr"] = mdSpacing.padding[1];
      className += `md:pr-[var(--md-pr)] `;
    }
    if (mdSpacing.padding[3] !== mobileSpacing.padding[3]) {
      styles["--md-pl"] = mdSpacing.padding[3];
      className += `md:pl-[var(--md-pl)] `;
    }
  }
  if (JSON.stringify(dSpacing.padding) !== JSON.stringify(mdSpacing.padding)) {
    if (dSpacing.padding[0] !== mdSpacing.padding[0]) {
      styles["--lg-pt"] = dSpacing.padding[0];
      className += `lg:pt-[var(--lg-pt)] `;
    }
    if (dSpacing.padding[2] !== mdSpacing.padding[2]) {
      styles["--lg-pb"] = dSpacing.padding[2];
      className += `lg:pb-[var(--lg-pb)] `;
    }
    if (dSpacing.padding[1] !== mdSpacing.padding[1]) {
      styles["--lg-pr"] = dSpacing.padding[1];
      className += `lg:pr-[var(--lg-pr)] `;
    }
    if (dSpacing.padding[3] !== mdSpacing.padding[3]) {
      styles["--lg-pl"] = dSpacing.padding[3];
      className += `lg:pl-[var(--lg-pl)] `;
    }
  }
  if (JSON.stringify(mobileSpacing.margin) !== '["0px","0px","0px","0px"]') {
    if (mobileSpacing.margin[0] !== "0px") {
      styles["--m-mt"] = mobileSpacing.margin[0];
      className += `mt-[var(--m-mt)] `;
    }
    if (mobileSpacing.margin[2] !== "0px") {
      styles["--m-mb"] = mobileSpacing.margin[2];
      className += `mb-[var(--m-mb)] `;
    }
    if (mobileSpacing.margin[1] !== "0px") {
      styles["--m-mr"] = mobileSpacing.margin[1];
      className += `mr-[var(--m-mr)] `;
    }
    if (mobileSpacing.margin[3] !== "0px") {
      styles["--m-ml"] = mobileSpacing.margin[3];
      className += `ml-[var(--m-ml)] `;
    }
  }
  if (JSON.stringify(mdSpacing.margin) !== JSON.stringify(mobileSpacing.margin)) {
    if (mdSpacing.margin[0] !== mobileSpacing.margin[0]) {
      styles["--md-mt"] = mdSpacing.margin[0];
      className += `md:mt-[var(--md-mt)] `;
    }
    if (mdSpacing.margin[2] !== mobileSpacing.margin[2]) {
      styles["--md-mb"] = mdSpacing.margin[2];
      className += `md:mb-[var(--md-mb)] `;
    }
    if (mdSpacing.margin[1] !== mobileSpacing.margin[1]) {
      styles["--md-mr"] = mdSpacing.margin[1];
      className += `md:mr-[var(--md-mr)] `;
    }
    if (mdSpacing.margin[3] !== mobileSpacing.margin[3]) {
      styles["--md-ml"] = mdSpacing.margin[3];
      className += `md:ml-[var(--md-ml)] `;
    }
  }
  if (JSON.stringify(dSpacing.margin) !== JSON.stringify(mdSpacing.margin)) {
    if (dSpacing.margin[0] !== mdSpacing.margin[0]) {
      styles["--lg-mt"] = dSpacing.margin[0];
      className += `lg:mt-[var(--lg-mt)] `;
    }
    if (dSpacing.margin[2] !== mdSpacing.margin[2]) {
      styles["--lg-mb"] = dSpacing.margin[2];
      className += `lg:mb-[var(--lg-mb)] `;
    }
    if (dSpacing.margin[1] !== mdSpacing.margin[1]) {
      styles["--lg-mr"] = dSpacing.margin[1];
      className += `lg:mr-[var(--lg-mr)] `;
    }
    if (dSpacing.margin[3] !== mdSpacing.margin[3]) {
      styles["--lg-ml"] = dSpacing.margin[3];
      className += `lg:ml-[var(--lg-ml)] `;
    }
  }
  return {
    styles,
    className
  };
};
const useTypography = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La, _Ma, _Na, _Oa, _Pa, _Qa, _Ra, _Sa, _Ta, _Ua, _Va, _Wa, _Xa, _Ya, _Za, __a, _$a, _ab, _bb, _cb, _db, _eb, _fb, _gb, _hb, _ib, _jb, _kb, _lb, _mb, _nb, _ob, _pb, _qb, _rb, _sb, _tb, _ub, _vb, _wb, _xb, _yb, _zb, _Ab, _Bb, _Cb, _Db, _Eb, _Fb, _Gb, _Hb, _Ib, _Jb, _Kb, _Lb, _Mb, _Nb, _Ob, _Pb, _Qb, _Rb, _Sb, _Tb, _Ub, _Vb, _Wb, _Xb, _Yb, _Zb, __b, _$b, _ac, _bc, _cc, _dc, _ec, _fc, _gc, _hc, _ic, _jc, _kc, _lc, _mc, _nc, _oc, _pc, _qc, _rc, _sc, _tc, _uc, _vc, _wc, _xc, _yc, _zc, _Ac, _Bc, _Cc, _Dc, _Ec, _Fc, _Gc, _Hc, _Ic, _Jc, _Kc, _Lc, _Mc, _Nc, _Oc, _Pc, _Qc, _Rc, _Sc, _Tc, _Uc, _Vc, _Wc, _Xc, _Yc, _Zc, __c, _$c, _ad, _bd;
  let classNames = "";
  const styles = {};
  const { colors, fontSize, fontWeight, lineHeight, fontFamily } = useUiKitTheme();
  if ((_a = props.m) == null ? void 0 : _a.color) {
    styles["--color"] = (_b = colors[props.m.color]) != null ? _b : props.m.color;
    classNames += `text-[color:var(--color)] `;
  }
  if (((_c = props.md) == null ? void 0 : _c.color) && props.md.color !== ((_d = props.m) == null ? void 0 : _d.color)) {
    styles["--md-color"] = (_e = colors[props.md.color]) != null ? _e : props.md.color;
    classNames += `md:text-[color:var(--md-color)] `;
  }
  const mdColor = (_h = (_f = props.md) == null ? void 0 : _f.color) != null ? _h : (_g = props.m) == null ? void 0 : _g.color;
  if (((_i = props.d) == null ? void 0 : _i.color) && props.d.color !== mdColor) {
    styles["--d-color"] = (_j = colors[props.d.color]) != null ? _j : props.d.color;
    classNames += `hover:text-[color:var(--d-color)] `;
  }
  if ((_k = props.hover.m) == null ? void 0 : _k.color) {
    styles["--hover-color"] = (_l = colors[props.hover.m.color]) != null ? _l : props.hover.m.color;
    classNames += `hover:text-[color:var(--hover-color)] `;
  }
  if (((_m = props.hover.md) == null ? void 0 : _m.color) && props.hover.md.color !== ((_n = props.hover.m) == null ? void 0 : _n.color)) {
    styles["--hover-md-color"] = (_o = colors[props.hover.md.color]) != null ? _o : props.hover.md.color;
    classNames += `hover:md:text-[color:var(--hover-md-color)] `;
  }
  const hoverMdColor = (_r = (_p = props.hover.md) == null ? void 0 : _p.color) != null ? _r : (_q = props.hover.m) == null ? void 0 : _q.color;
  if (((_s = props.hover.d) == null ? void 0 : _s.color) && props.hover.d.color !== hoverMdColor) {
    styles["--hover-d-color"] = (_t = colors[props.hover.d.color]) != null ? _t : props.hover.d.color;
    classNames += `hover:lg:text-[color:var(--hover-d-color)] `;
  }
  if (typeof ((_u = props.m) == null ? void 0 : _u.fontSize) !== "undefined") {
    const fontSizeValue = (_v = fontSize[props.m.fontSize]) != null ? _v : props.m.fontSize;
    styles["--fs"] = propertyTransformer(fontSizeValue);
    classNames += `[font-size:var(--fs)] `;
  }
  if (typeof ((_w = props.md) == null ? void 0 : _w.fontSize) !== "undefined" && props.md.fontSize !== ((_x = props.m) == null ? void 0 : _x.fontSize)) {
    const mdFontSizeValue = (_y = fontSize[props.md.fontSize]) != null ? _y : props.md.fontSize;
    styles["--md-fs"] = propertyTransformer(mdFontSizeValue);
    classNames += `md:[font-size:var(--md-fs)] `;
  }
  const mdFontSize = (_B = (_z = props.md) == null ? void 0 : _z.fontSize) != null ? _B : (_A = props.m) == null ? void 0 : _A.fontSize;
  if (typeof ((_C = props.d) == null ? void 0 : _C.fontSize) !== "undefined" && props.d.fontSize !== mdFontSize) {
    const dFontSizeValue = (_D = fontSize[props.d.fontSize]) != null ? _D : props.d.fontSize;
    styles["--d-fs"] = propertyTransformer(dFontSizeValue);
    classNames += `lg:[font-size:var(--d-fs)] `;
  }
  if (typeof ((_E = props.hover.m) == null ? void 0 : _E.fontSize) !== "undefined") {
    const fontSizeValue = (_G = fontSize[props.hover.m.fontSize]) != null ? _G : (_F = props.hover.m) == null ? void 0 : _F.fontSize;
    styles["--hover-fs"] = propertyTransformer(fontSizeValue);
    classNames += `hover:[font-size:var(--hover-fs)] `;
  }
  if (typeof ((_H = props.hover.md) == null ? void 0 : _H.fontSize) !== "undefined" && props.hover.md.fontSize !== ((_I = props.hover.m) == null ? void 0 : _I.fontSize)) {
    const mdFontSizeValue = (_J = fontSize[props.hover.md.fontSize]) != null ? _J : props.hover.md.fontSize;
    styles["--hover-md-fs"] = propertyTransformer(mdFontSizeValue);
    classNames += `md:hover:[font-size:var(--hover-md-fs)] `;
  }
  const hoverMdFontSize = (_M = (_K = props.hover.md) == null ? void 0 : _K.fontSize) != null ? _M : (_L = props.hover.m) == null ? void 0 : _L.fontSize;
  if (typeof ((_N = props.hover.d) == null ? void 0 : _N.fontSize) !== "undefined" && props.hover.d.fontSize !== hoverMdFontSize) {
    const dFontSizeValue = (_O = fontSize[props.hover.d.fontSize]) != null ? _O : props.hover.d.fontSize;
    styles["--hover-d-fs"] = propertyTransformer(dFontSizeValue);
    classNames += `lg:hover:[font-size:var(--hover-d-fs)] `;
  }
  if (typeof ((_P = props.m) == null ? void 0 : _P.fontWeight) !== "undefined") {
    styles["--fw"] = (_S = fontWeight[(_Q = props.m) == null ? void 0 : _Q.fontWeight]) != null ? _S : (_R = props.m) == null ? void 0 : _R.fontWeight;
    classNames += `[font-weight:var(--fw)] `;
  }
  if (typeof ((_T = props.md) == null ? void 0 : _T.fontWeight) !== "undefined" && props.md.fontWeight !== ((_U = props.m) == null ? void 0 : _U.fontWeight)) {
    styles["--md-fw"] = (_V = fontWeight[props.md.fontWeight]) != null ? _V : props.md.fontWeight;
    classNames += `md:[font-weight:var(--md-fw)] `;
  }
  const mdFontWeight = (_Y = (_W = props.md) == null ? void 0 : _W.fontWeight) != null ? _Y : (_X = props.m) == null ? void 0 : _X.fontWeight;
  if (typeof ((_Z = props.d) == null ? void 0 : _Z.fontWeight) !== "undefined" && props.d.fontWeight !== mdFontWeight) {
    styles["--d-fw"] = (__ = fontWeight[props.d.fontWeight]) != null ? __ : props.d.fontWeight;
    classNames += `lg:[font-weight:var(--d-fw)] `;
  }
  if (typeof ((_$ = props.hover.m) == null ? void 0 : _$.fontWeight) !== "undefined") {
    styles["--hover-fw"] = (_aa = fontWeight[props.hover.m.fontWeight]) != null ? _aa : props.hover.m.fontWeight;
    classNames += `hover:[font-weight:var(--hover-fw)] `;
  }
  if (typeof ((_ba = props.hover.md) == null ? void 0 : _ba.fontWeight) !== "undefined" && props.hover.md.fontWeight !== ((_ca = props.hover.m) == null ? void 0 : _ca.fontWeight)) {
    styles["--hover-md-fw"] = (_da = fontWeight[props.hover.md.fontWeight]) != null ? _da : props.hover.md.fontWeight;
    classNames += `md:hover:[font-weight:var(--hover-md-fw)] `;
  }
  const hoverMdFontWeight = (_ga = (_ea = props.hover.md) == null ? void 0 : _ea.fontWeight) != null ? _ga : (_fa = props.hover.m) == null ? void 0 : _fa.fontWeight;
  if (typeof ((_ha = props.hover.d) == null ? void 0 : _ha.fontWeight) !== "undefined" && props.hover.d.fontWeight !== hoverMdFontWeight) {
    styles["--hover-d-fw"] = (_ia = fontWeight[props.hover.d.fontWeight]) != null ? _ia : props.hover.d.fontWeight;
    classNames += `lg:hover:[font-weight:var(--hover-d-fw)] `;
  }
  if (typeof ((_ja = props.m) == null ? void 0 : _ja.lineHeight) !== "undefined") {
    const lineHeightValue = (_ka = lineHeight[props.m.lineHeight]) != null ? _ka : props.m.lineHeight;
    styles["--lh"] = propertyTransformer(lineHeightValue);
    classNames += `[line-height:var(--lh)] `;
  }
  if (typeof ((_la = props.md) == null ? void 0 : _la.lineHeight) !== "undefined" && props.md.lineHeight !== ((_ma = props.m) == null ? void 0 : _ma.lineHeight)) {
    const mdLineHeightValue = (_na = lineHeight[props.md.lineHeight]) != null ? _na : props.md.lineHeight;
    styles["--md-lh"] = propertyTransformer(mdLineHeightValue);
    classNames += `md:[line-height:var(--md-lh)] `;
  }
  const mdLineHeight = (_qa = (_oa = props.md) == null ? void 0 : _oa.lineHeight) != null ? _qa : (_pa = props.m) == null ? void 0 : _pa.lineHeight;
  if (typeof ((_ra = props.d) == null ? void 0 : _ra.lineHeight) !== "undefined" && props.d.lineHeight !== mdLineHeight) {
    const dLineHeightValue = (_sa = lineHeight[props.d.lineHeight]) != null ? _sa : props.d.lineHeight;
    styles["--d-lh"] = propertyTransformer(dLineHeightValue);
    classNames += `lg:[line-height:var(--d-lh)] `;
  }
  if (typeof ((_ta = props.hover.m) == null ? void 0 : _ta.lineHeight) !== "undefined") {
    const lineHeightValue = (_ua = lineHeight[props.hover.m.lineHeight]) != null ? _ua : props.hover.m.lineHeight;
    styles["--hover-lh"] = propertyTransformer(lineHeightValue);
    classNames += `hover:[line-height:var(--hover-lh)] `;
  }
  if (typeof ((_va = props.hover.md) == null ? void 0 : _va.lineHeight) !== "undefined" && props.hover.md.lineHeight !== ((_wa = props.hover.m) == null ? void 0 : _wa.lineHeight)) {
    const mdLineHeightValue = (_xa = lineHeight[props.hover.md.lineHeight]) != null ? _xa : props.hover.md.lineHeight;
    styles["--hover-md-lh"] = propertyTransformer(mdLineHeightValue);
    classNames += `md:hover:[line-height:var(--hover-md-lh)] `;
  }
  const hoverMdLineHeight = (_Aa = (_ya = props.hover.md) == null ? void 0 : _ya.lineHeight) != null ? _Aa : (_za = props.hover.m) == null ? void 0 : _za.lineHeight;
  if (typeof ((_Ba = props.hover.d) == null ? void 0 : _Ba.lineHeight) !== "undefined" && ((_Ca = props.hover.d) == null ? void 0 : _Ca.lineHeight) !== hoverMdLineHeight) {
    const dLineHeightValue = (_Da = lineHeight[props.hover.d.lineHeight]) != null ? _Da : props.hover.d.lineHeight;
    styles["--hover-d-lh"] = propertyTransformer(dLineHeightValue);
    classNames += `lg:hover:[line-height:var(--hover-d-lh)] `;
  }
  if (((_Ea = props.m) == null ? void 0 : _Ea.italic) === true) {
    classNames += `italic `;
  }
  if (((_Fa = props.md) == null ? void 0 : _Fa.italic) === true && ((_Ga = props.md) == null ? void 0 : _Ga.italic) !== ((_Ha = props.m) == null ? void 0 : _Ha.italic)) {
    classNames += `md:italic `;
  }
  if (((_Ia = props.d) == null ? void 0 : _Ia.italic) === true && ((_Ja = props.d) == null ? void 0 : _Ja.italic) !== ((_Ma = (_Ka = props.md) == null ? void 0 : _Ka.italic) != null ? _Ma : (_La = props.m) == null ? void 0 : _La.italic)) {
    classNames += `lg:italic `;
  }
  if (((_Na = props.hover.m) == null ? void 0 : _Na.italic) === true) {
    classNames += `hover:italic `;
  }
  if (((_Oa = props.hover.md) == null ? void 0 : _Oa.italic) === true && ((_Pa = props.hover.md) == null ? void 0 : _Pa.italic) !== ((_Qa = props.hover.m) == null ? void 0 : _Qa.italic)) {
    classNames += `md:hover:italic `;
  }
  if (((_Ra = props.hover.d) == null ? void 0 : _Ra.italic) === true && ((_Sa = props.hover.d) == null ? void 0 : _Sa.italic) !== ((_Va = (_Ta = props.hover.md) == null ? void 0 : _Ta.italic) != null ? _Va : (_Ua = props.hover.m) == null ? void 0 : _Ua.italic)) {
    classNames += `lg:hover:italic `;
  }
  if ((_Wa = props.m) == null ? void 0 : _Wa.verticalAlign) {
    classNames += `align-${props.m.verticalAlign} `;
  }
  if (((_Xa = props.md) == null ? void 0 : _Xa.verticalAlign) && props.md.verticalAlign !== ((_Ya = props.m) == null ? void 0 : _Ya.verticalAlign)) {
    classNames += `md:align-${props.md.verticalAlign} `;
  }
  const mdVerticalAlign = (_$a = (_Za = props.md) == null ? void 0 : _Za.verticalAlign) != null ? _$a : (__a = props.m) == null ? void 0 : __a.verticalAlign;
  if (((_ab = props.d) == null ? void 0 : _ab.verticalAlign) && props.d.verticalAlign !== mdVerticalAlign) {
    classNames += `lg:align-${props.d.verticalAlign} `;
  }
  if ((_bb = props.hover.m) == null ? void 0 : _bb.verticalAlign) {
    classNames += `hover:align-${props.hover.m.verticalAlign} `;
  }
  if (((_cb = props.hover.md) == null ? void 0 : _cb.verticalAlign) && props.hover.md.verticalAlign !== ((_db = props.hover.m) == null ? void 0 : _db.verticalAlign)) {
    classNames += `md:hover:align-${props.hover.md.verticalAlign} `;
  }
  const hoverMdVerticalAlign = (_gb = (_eb = props.hover.md) == null ? void 0 : _eb.verticalAlign) != null ? _gb : (_fb = props.hover.m) == null ? void 0 : _fb.verticalAlign;
  if (((_hb = props.hover.d) == null ? void 0 : _hb.verticalAlign) && props.hover.d.verticalAlign !== hoverMdVerticalAlign) {
    classNames += `lg:hover:align-${props.hover.d.verticalAlign} `;
  }
  if ((_ib = props.m) == null ? void 0 : _ib.horizontalAlign) {
    classNames += `text-${props.m.horizontalAlign} `;
  }
  if (((_jb = props.md) == null ? void 0 : _jb.horizontalAlign) && props.md.horizontalAlign !== ((_kb = props.m) == null ? void 0 : _kb.horizontalAlign)) {
    classNames += `md:text-${props.md.horizontalAlign} `;
  }
  const mdHorizontalAlign = (_nb = (_lb = props.md) == null ? void 0 : _lb.horizontalAlign) != null ? _nb : (_mb = props.m) == null ? void 0 : _mb.horizontalAlign;
  if (((_ob = props.d) == null ? void 0 : _ob.horizontalAlign) && props.d.horizontalAlign !== mdHorizontalAlign) {
    classNames += `lg:text-${props.d.horizontalAlign} `;
  }
  if ((_pb = props.hover.m) == null ? void 0 : _pb.horizontalAlign) {
    classNames += `hover:text-${props.hover.m.horizontalAlign} `;
  }
  if (((_qb = props.hover.md) == null ? void 0 : _qb.horizontalAlign) && props.hover.md.horizontalAlign !== ((_rb = props.hover.m) == null ? void 0 : _rb.horizontalAlign)) {
    classNames += `md:hover:text-${props.hover.md.horizontalAlign} `;
  }
  const hoverMdHorizontalAlign = (_ub = (_sb = props.hover.md) == null ? void 0 : _sb.horizontalAlign) != null ? _ub : (_tb = props.hover.m) == null ? void 0 : _tb.horizontalAlign;
  if (((_vb = props.hover.d) == null ? void 0 : _vb.horizontalAlign) && props.hover.d.horizontalAlign !== hoverMdHorizontalAlign) {
    classNames += `lg:hover:text-${props.hover.d.horizontalAlign} `;
  }
  if ((_wb = props.m) == null ? void 0 : _wb.textTransform) {
    classNames += `${props.m.textTransform} `;
  }
  if (((_xb = props.md) == null ? void 0 : _xb.textTransform) && props.md.textTransform !== ((_yb = props.m) == null ? void 0 : _yb.textTransform)) {
    classNames += `md:${props.md.textTransform} `;
  }
  const mdTextTransform = (_Bb = (_zb = props.md) == null ? void 0 : _zb.textTransform) != null ? _Bb : (_Ab = props.m) == null ? void 0 : _Ab.textTransform;
  if (((_Cb = props.d) == null ? void 0 : _Cb.textTransform) && props.d.textTransform !== mdTextTransform) {
    classNames += `lg:${props.d.textTransform} `;
  }
  if ((_Db = props.hover.m) == null ? void 0 : _Db.textTransform) {
    classNames += `hover:${props.hover.m.textTransform} `;
  }
  if (((_Eb = props.hover.md) == null ? void 0 : _Eb.textTransform) && props.hover.md.textTransform !== ((_Fb = props.hover.m) == null ? void 0 : _Fb.textTransform)) {
    classNames += `md:hover:${props.hover.md.textTransform} `;
  }
  const hoverMdTextTransform = (_Ib = (_Gb = props.hover.md) == null ? void 0 : _Gb.textTransform) != null ? _Ib : (_Hb = props.hover.m) == null ? void 0 : _Hb.textTransform;
  if (((_Jb = props.hover.d) == null ? void 0 : _Jb.textTransform) && props.hover.d.textTransform !== hoverMdTextTransform) {
    classNames += `lg:hover:${props.hover.d.textTransform} `;
  }
  if ((_Kb = props.m) == null ? void 0 : _Kb.textDecoration) {
    classNames += `${props.m.textDecoration} `;
  }
  if (((_Lb = props.md) == null ? void 0 : _Lb.textDecoration) && props.md.textDecoration !== ((_Mb = props.m) == null ? void 0 : _Mb.textDecoration)) {
    classNames += `md:${props.md.textDecoration} `;
  }
  const mdTextDecoration = (_Pb = (_Nb = props.md) == null ? void 0 : _Nb.textDecoration) != null ? _Pb : (_Ob = props.m) == null ? void 0 : _Ob.textDecoration;
  if (((_Qb = props.d) == null ? void 0 : _Qb.textDecoration) && props.d.textDecoration !== mdTextDecoration) {
    classNames += `lg:${props.d.textDecoration} `;
  }
  if ((_Rb = props.hover.m) == null ? void 0 : _Rb.textDecoration) {
    classNames += `hover:${props.hover.m.textDecoration} `;
  }
  if (((_Sb = props.hover.md) == null ? void 0 : _Sb.textDecoration) && props.hover.md.textDecoration !== ((_Tb = props.hover.m) == null ? void 0 : _Tb.textDecoration)) {
    classNames += `md:hover:${props.hover.md.textDecoration} `;
  }
  const hoverMdTextDecoration = (_Wb = (_Ub = props.hover.md) == null ? void 0 : _Ub.textDecoration) != null ? _Wb : (_Vb = props.hover.m) == null ? void 0 : _Vb.textDecoration;
  if (((_Xb = props.hover.d) == null ? void 0 : _Xb.textDecoration) && props.hover.d.textDecoration !== hoverMdTextDecoration) {
    classNames += `lg:hover:${props.hover.d.textDecoration} `;
  }
  if ((_Yb = props.m) == null ? void 0 : _Yb.textOverflow) {
    classNames += `text-${props.m.textOverflow} `;
  }
  if (((_Zb = props.md) == null ? void 0 : _Zb.textOverflow) && props.md.textOverflow !== ((__b = props.m) == null ? void 0 : __b.textOverflow)) {
    classNames += `md:text-${props.md.textOverflow} `;
  }
  const mdTextOverflow = (_bc = (_$b = props.md) == null ? void 0 : _$b.textOverflow) != null ? _bc : (_ac = props.m) == null ? void 0 : _ac.textOverflow;
  if (((_cc = props.d) == null ? void 0 : _cc.textOverflow) && props.d.textOverflow !== mdTextOverflow) {
    classNames += `lg:text-${props.d.textOverflow} `;
  }
  if ((_dc = props.hover.m) == null ? void 0 : _dc.textOverflow) {
    classNames += `hover:text-${props.hover.m.textOverflow} `;
  }
  if (((_ec = props.hover.md) == null ? void 0 : _ec.textOverflow) && props.hover.md.textOverflow !== ((_fc = props.hover.m) == null ? void 0 : _fc.textOverflow)) {
    classNames += `md:hover:text-${props.hover.md.textOverflow} `;
  }
  const hoverMdTextOverflow = (_ic = (_gc = props.hover.md) == null ? void 0 : _gc.textOverflow) != null ? _ic : (_hc = props.hover.m) == null ? void 0 : _hc.textOverflow;
  if (((_jc = props.hover.d) == null ? void 0 : _jc.textOverflow) && props.hover.d.textOverflow !== hoverMdTextOverflow) {
    classNames += `lg:hover:text-${props.hover.d.textOverflow} `;
  }
  if ((_kc = props.m) == null ? void 0 : _kc.whiteSpace) {
    classNames += `whitespace-${props.m.whiteSpace} `;
  }
  if (((_lc = props.md) == null ? void 0 : _lc.whiteSpace) && props.md.whiteSpace !== ((_mc = props.m) == null ? void 0 : _mc.whiteSpace)) {
    classNames += `md:whitespace-${props.md.whiteSpace} `;
  }
  const mdWhiteSpace = (_pc = (_nc = props.md) == null ? void 0 : _nc.whiteSpace) != null ? _pc : (_oc = props.m) == null ? void 0 : _oc.whiteSpace;
  if (((_qc = props.d) == null ? void 0 : _qc.whiteSpace) && props.d.whiteSpace !== mdWhiteSpace) {
    classNames += `lg:whitespace-${props.d.whiteSpace} `;
  }
  if ((_rc = props.hover.m) == null ? void 0 : _rc.whiteSpace) {
    classNames += `hover:whitespace-${props.hover.m.whiteSpace} `;
  }
  if (((_sc = props.hover.md) == null ? void 0 : _sc.whiteSpace) && props.hover.md.whiteSpace !== ((_tc = props.hover.m) == null ? void 0 : _tc.whiteSpace)) {
    classNames += `md:hover:whitespace-${props.hover.md.whiteSpace} `;
  }
  const hoverMdWhiteSpace = (_wc = (_uc = props.hover.md) == null ? void 0 : _uc.whiteSpace) != null ? _wc : (_vc = props.hover.m) == null ? void 0 : _vc.whiteSpace;
  if (((_xc = props.hover.d) == null ? void 0 : _xc.whiteSpace) && props.hover.d.whiteSpace !== hoverMdWhiteSpace) {
    classNames += `lg:hover:whitespace-${props.hover.d.whiteSpace} `;
  }
  if ((_yc = props.m) == null ? void 0 : _yc.fontFamily) {
    const fontFamilyValue = fontFamily[`${props.m.fontFamily}_name`];
    styles["--ff"] = fontFamilyValue;
    classNames += `[font-family:var(--ff)] `;
  }
  if (((_zc = props.md) == null ? void 0 : _zc.fontFamily) && ((_Ac = props.md) == null ? void 0 : _Ac.fontFamily) !== ((_Bc = props.m) == null ? void 0 : _Bc.fontFamily)) {
    const fontFamilyValue = fontFamily[`${props.md.fontFamily}_name`];
    styles["--md-ff"] = fontFamilyValue;
    classNames += `md:[font-family:var(--md-ff)] `;
  }
  const mdFontFamily = (_Ec = (_Cc = props.md) == null ? void 0 : _Cc.fontFamily) != null ? _Ec : (_Dc = props.m) == null ? void 0 : _Dc.fontFamily;
  if (((_Fc = props.d) == null ? void 0 : _Fc.fontFamily) && ((_Gc = props.d) == null ? void 0 : _Gc.fontFamily) !== mdFontFamily) {
    const fontFamilyValue = fontFamily[`${props.d.fontFamily}_name`];
    styles["--d-ff"] = fontFamilyValue;
    classNames += `lg:[font-family:var(--d-ff)] `;
  }
  if ((_Hc = props.hover.m) == null ? void 0 : _Hc.fontFamily) {
    const fontFamilyValue = fontFamily[`${props.hover.m.fontFamily}_name`];
    styles["--hover-ff"] = fontFamilyValue;
    classNames += `hover:[font-family:var(--hover-ff)] `;
  }
  if (((_Ic = props.hover.md) == null ? void 0 : _Ic.fontFamily) && ((_Jc = props.hover.md) == null ? void 0 : _Jc.fontFamily) !== ((_Kc = props.hover.m) == null ? void 0 : _Kc.fontFamily)) {
    const fontFamilyValue = fontFamily[`${props.hover.md.fontFamily}_name`];
    styles["--hover-md-ff"] = fontFamilyValue;
    classNames += `md:hover:[font-family:var(--hover-md-ff)] `;
  }
  const hoverMdFontFamily = (_Nc = (_Lc = props.hover.md) == null ? void 0 : _Lc.fontFamily) != null ? _Nc : (_Mc = props.hover.m) == null ? void 0 : _Mc.fontFamily;
  if (((_Oc = props.hover.d) == null ? void 0 : _Oc.fontFamily) && ((_Pc = props.hover.d) == null ? void 0 : _Pc.fontFamily) !== hoverMdFontFamily) {
    const fontFamilyValue = fontFamily[`${props.hover.d.fontFamily}_name`];
    styles["--hover-d-ff"] = fontFamilyValue;
    classNames += `lg:hover:[font-family:var(--hover-d-ff)] `;
  }
  if ((_Qc = props.m) == null ? void 0 : _Qc.wordBreak) {
    classNames += `break-${props.m.wordBreak} `;
  }
  if (((_Rc = props.md) == null ? void 0 : _Rc.wordBreak) && props.md.wordBreak !== ((_Sc = props.m) == null ? void 0 : _Sc.wordBreak)) {
    classNames += `md:break-${props.md.wordBreak} `;
  }
  const mdWordBreak = (_Vc = (_Tc = props.md) == null ? void 0 : _Tc.wordBreak) != null ? _Vc : (_Uc = props.m) == null ? void 0 : _Uc.wordBreak;
  if (((_Wc = props.d) == null ? void 0 : _Wc.wordBreak) && props.d.wordBreak !== mdWordBreak) {
    classNames += `lg:break-${props.d.wordBreak} `;
  }
  if ((_Xc = props.hover.m) == null ? void 0 : _Xc.wordBreak) {
    classNames += `hover:break-${props.hover.m.wordBreak} `;
  }
  if (((_Yc = props.hover.md) == null ? void 0 : _Yc.wordBreak) && props.hover.md.wordBreak !== ((_Zc = props.hover.m) == null ? void 0 : _Zc.wordBreak)) {
    classNames += `md:hover:break-${props.hover.md.wordBreak} `;
  }
  const hoverMdWordBreak = (_ad = (__c = props.hover.md) == null ? void 0 : __c.wordBreak) != null ? _ad : (_$c = props.hover.m) == null ? void 0 : _$c.wordBreak;
  if (((_bd = props.hover.d) == null ? void 0 : _bd.wordBreak) && props.hover.d.wordBreak !== hoverMdWordBreak) {
    classNames += `lg:hover:break-${props.hover.d.wordBreak} `;
  }
  return {
    classNames,
    styles
  };
};
const Box = forwardRef(
  ({
    md,
    d,
    className,
    children,
    as,
    position,
    hover,
    active,
    groupParent = false,
    onClick,
    ...rest
  }, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
    const spacing = useSpacing({ m: rest, d, md });
    const dimension = useDimensions({ m: rest, md, d });
    const positionStyles = usePosition({
      m: position ? { position } : void 0,
      md: (md == null ? void 0 : md.position) ? { position: md.position } : void 0,
      d: (d == null ? void 0 : d.position) ? { position: d.position } : void 0
    });
    const background = useBackground({
      m: {
        ...rest,
        bgSize: (_a = rest.bgSize) != null ? _a : "cover",
        bgRepeat: (_b = rest.bgRepeat) != null ? _b : "no-repeat",
        bgPosition: (_c = rest.bgPosition) != null ? _c : "center"
      },
      md: md != null ? md : {},
      d: d != null ? d : {},
      hover: { m: hover != null ? hover : {}, md: (_d = md == null ? void 0 : md.hover) != null ? _d : {}, d: (_e = d == null ? void 0 : d.hover) != null ? _e : {} }
    });
    const display = useDisplay({
      m: { display: (_f = rest.display) != null ? _f : "block" },
      md: { display: md == null ? void 0 : md.display },
      d: { display: d == null ? void 0 : d.display }
    });
    const typography = useTypography({
      m: rest,
      md: md != null ? md : {},
      d: d != null ? d : {},
      hover: { m: hover != null ? hover : {}, md: (_g = md == null ? void 0 : md.hover) != null ? _g : {}, d: (_h = d == null ? void 0 : d.hover) != null ? _h : {} }
    });
    const border = useBorder({
      m: rest.border,
      md: md == null ? void 0 : md.border,
      d: d == null ? void 0 : d.border,
      hover: { m: hover == null ? void 0 : hover.border, md: (_i = md == null ? void 0 : md.hover) == null ? void 0 : _i.border, d: (_j = d == null ? void 0 : d.hover) == null ? void 0 : _j.border }
    });
    const outline = useOutline({
      m: rest,
      md,
      d,
      hover: { md: (_k = md == null ? void 0 : md.hover) != null ? _k : {}, d: (_l = d == null ? void 0 : d.hover) != null ? _l : {} }
    });
    const effects = useCssEffects({
      m: rest,
      md,
      d,
      hover: { m: hover != null ? hover : {}, md: (_m = md == null ? void 0 : md.hover) != null ? _m : {}, d: (_n = d == null ? void 0 : d.hover) != null ? _n : {} }
    });
    const animation = useAnimation({
      m: rest,
      md,
      d,
      hover: { m: hover != null ? hover : {}, md: (_o = md == null ? void 0 : md.hover) != null ? _o : {}, d: (_p = d == null ? void 0 : d.hover) != null ? _p : {} },
      active: { m: active != null ? active : {}, md: (_q = md == null ? void 0 : md.active) != null ? _q : {}, d: (_r = d == null ? void 0 : d.active) != null ? _r : {} }
    });
    const cursor = useCursor({ m: rest, md, d });
    const listStyle = useListStyle({ m: rest, md, d });
    const resolvedProps = useResolvedAttributes(rest);
    const Root = as != null ? as : "div";
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      animation.keyFrames && /* @__PURE__ */ jsx("style", { children: animation.keyFrames }),
      /* @__PURE__ */ jsx(
        Root,
        {
          ...resolvedProps,
          ref,
          className: `${display.classNames} ${effects.className} ${outline.className} ${border.className} ${spacing.className} ${positionStyles.className} ${background.className} ${dimension.className} ${typography.classNames} ${groupParent ? "group" : ""} ${cursor.className} ${listStyle.className} ${animation.className} ${className != null ? className : ""}`,
          onClick: (e) => {
            onClick == null ? void 0 : onClick(e);
          },
          style: {
            ...outline.style,
            ...border.style,
            ...spacing.styles,
            ...dimension.styles,
            ...positionStyles.styles,
            ...background.style,
            ...typography.styles,
            ...effects.style,
            ...cursor.style,
            ...listStyle.style,
            ...animation.style,
            ...rest.style
          },
          children
        }
      )
    ] });
  }
);
const spanVariants = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12",
  default: "col-auto"
};
const GridItem = (props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    cSpan = "default",
    rSpan,
    md,
    d,
    className,
    children
  } = props;
  const gridItemStyles = ce({
    base: `${className != null ? className : ""} ${spanVariants[cSpan]}  md:${spanVariants[(_a = md == null ? void 0 : md.cSpan) != null ? _a : cSpan]}`
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      style: {
        "--rowSpan": String(rSpan),
        "--mdRowSpan": String((_b = md == null ? void 0 : md.rSpan) != null ? _b : rSpan),
        "--dRowSpan": String((_d = (_c = d == null ? void 0 : d.rSpan) != null ? _c : md == null ? void 0 : md.rSpan) != null ? _d : rSpan),
        "--colSpan": cSpan,
        "--mdColSpan": (_e = md == null ? void 0 : md.cSpan) != null ? _e : cSpan,
        "--dColSpan": (_g = (_f = d == null ? void 0 : d.cSpan) != null ? _f : md == null ? void 0 : md.cSpan) != null ? _g : cSpan
      },
      className: gridItemStyles(),
      ...props,
      children
    }
  );
};
const styleTransformer = (value) => {
  return typeof value === "string" ? value : `${value}px`;
};
const Grid = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    children,
    cols,
    gap,
    md,
    d,
    className = "",
    display = "grid"
  } = props;
  const gridStyles = ce({
    base: `gap-[var(--gap)]   md:gap-[var(--mdGap)] lg:gap-[var(--dGap)] ${className} grid grid-cols-[repeat(var(--cols),1fr)] md:grid-cols-[repeat(var(--mdCols),1fr)] lg:grid-cols-[repeat(var(--dCols),1fr)]`
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...props,
      display,
      style: {
        "--cols": cols,
        "--mdCols": (_a = md == null ? void 0 : md.cols) != null ? _a : cols,
        "--dCols": (_c = (_b = d == null ? void 0 : d.cols) != null ? _b : md == null ? void 0 : md.cols) != null ? _c : cols,
        "--gap": styleTransformer(gap != null ? gap : 0),
        "--mdGap": styleTransformer((_e = (_d = md == null ? void 0 : md.gap) != null ? _d : gap) != null ? _e : 0),
        "--dGap": styleTransformer((_h = (_g = (_f = d == null ? void 0 : d.gap) != null ? _f : md == null ? void 0 : md.gap) != null ? _g : gap) != null ? _h : 0)
      },
      className: gridStyles(),
      children
    }
  );
};
Grid.Item = GridItem;
export {
  Box as B,
  Grid as G,
  useDisplay as a,
  useDimensions as b,
  ce as c,
  useTypography as d,
  useBackground as e,
  useBorder as f,
  useAnimation as g,
  usePosition as h,
  useCursor as i,
  useResolvedAttributes as j,
  useOutline as k,
  useSpacing as u
};
